import { FC } from "react";
import { twMerge } from "tailwind-merge";

interface IIcon {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
  isActive?: boolean;
  hasHoverState?: boolean;
  pathClassName?: string;
}

export const ChevronDown: FC<IIcon> = ({
  width = 10,
  height = 5,
  className = "",
  color = "#858795",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0L5 5L10 0H0Z" fill={color} />
    </svg>
  );
};

export const CalendarIcon: FC<IIcon> = ({
  width = 24,
  height = 24,
  className = "",
  color = "#C4C4C4",
  isActive = false,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 11H9V13H7V11ZM7 15H9V17H7V15ZM11 11H13V13H11V11ZM11 15H13V17H11V15ZM15 11H17V13H15V11ZM15 15H17V17H15V15Z"
      fill={isActive === true ? "#3699FF" : color}
    />
    <path
      d="M5 22H19C20.103 22 21 21.103 21 20V6C21 4.897 20.103 4 19 4H17V2H15V4H9V2H7V4H5C3.897 4 3 4.897 3 6V20C3 21.103 3.897 22 5 22ZM19 8L19.001 20H5V8H19Z"
      fill={isActive === true ? "#3699FF" : color}
    />
  </svg>
);

export const SortIcon: FC<IIcon> = ({
  width = 7,
  height = 15,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 7 15"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 9.88238L3.5 14.3824L0.75 9.88238H6.25ZM0.75 5.11768L3.5 0.617676L6.25 5.11768H0.75Z"
      fill="#C4C4C4"
    />
  </svg>
);

export const InfoIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM8.93 6.588L7.93 11.293C7.86 11.633 7.959 11.826 8.234 11.826C8.428 11.826 8.721 11.756 8.92 11.58L8.832 11.996C8.545 12.342 7.912 12.594 7.367 12.594C6.664 12.594 6.365 12.172 6.559 11.275L7.297 7.807C7.361 7.514 7.303 7.408 7.01 7.337L6.559 7.256L6.641 6.875L8.931 6.588H8.93ZM8 5.5C7.73478 5.5 7.48043 5.39464 7.29289 5.20711C7.10536 5.01957 7 4.76522 7 4.5C7 4.23478 7.10536 3.98043 7.29289 3.79289C7.48043 3.60536 7.73478 3.5 8 3.5C8.26522 3.5 8.51957 3.60536 8.70711 3.79289C8.89464 3.98043 9 4.23478 9 4.5C9 4.76522 8.89464 5.01957 8.70711 5.20711C8.51957 5.39464 8.26522 5.5 8 5.5Z"
      fill="#C4C4C4"
    />
  </svg>
);

export const CloseIcon: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 1.575L16.425 0L9 7.425L1.575 0L0 1.575L7.425 9L0 16.425L1.575 18L9 10.575L16.425 18L18 16.425L10.575 9L18 1.575Z"
      fill={color}
      className={className}
    />
  </svg>
);

export const RoundedCloseIcon: FC<IIcon> = ({
  width = 8,
  height = 9,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.17678 2.20178L7.35355 2.025L7.17678 1.84822L6.65178 1.32322L6.475 1.14645L6.29822 1.32322L4 3.62145L1.70178 1.32322L1.525 1.14645L1.34822 1.32322L0.823223 1.84822L0.646447 2.025L0.823223 2.20178L3.12145 4.5L0.823223 6.79822L0.646447 6.975L0.823223 7.15178L1.34822 7.67678L1.525 7.85355L1.70178 7.67678L4 5.37855L6.29822 7.67678L6.475 7.85355L6.65178 7.67678L7.17678 7.15178L7.35355 6.975L7.17678 6.79822L4.87855 4.5L7.17678 2.20178Z"
      fill="#464E5F"
      stroke="black"
      strokeWidth="0.5"
    />
  </svg>
);

export const SendIcon: FC<IIcon> = ({
  width = 17,
  height = 17,
  className = "",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.720784 0.050887L16.0758 7.61689C16.1595 7.65815 16.23 7.72203 16.2793 7.80129C16.3286 7.88055 16.3548 7.97204 16.3548 8.06539C16.3548 8.15873 16.3286 8.25022 16.2793 8.32948C16.23 8.40874 16.1595 8.47262 16.0758 8.51389L0.719784 16.0799C0.633756 16.1221 0.537394 16.1388 0.442174 16.1278C0.346955 16.1169 0.256891 16.0788 0.182709 16.0181C0.108526 15.9574 0.0533524 15.8767 0.023758 15.7855C-0.00583645 15.6943 -0.00860405 15.5966 0.0157845 15.5039L1.53678 9.75889C1.56144 9.66592 1.61238 9.58205 1.68351 9.51731C1.75463 9.45257 1.84292 9.40971 1.93778 9.39389L8.81878 8.24689C8.85979 8.24009 8.89845 8.22319 8.93128 8.1977C8.9641 8.1722 8.99005 8.13893 9.00678 8.10089L9.02478 8.04089C9.03412 7.98528 9.02438 7.92814 8.99715 7.87876C8.96992 7.82939 8.9268 7.79066 8.87478 7.76889L8.81878 7.75289L1.89978 6.59989C1.8051 6.58388 1.71703 6.54095 1.6461 6.47622C1.57516 6.4115 1.52437 6.32771 1.49978 6.23489L0.0157845 0.627887C-0.00885774 0.535126 -0.0062816 0.437234 0.0232055 0.345898C0.0526927 0.254562 0.107845 0.173643 0.182076 0.112803C0.256307 0.0519629 0.34648 0.0137732 0.441828 0.00279416C0.537175 -0.00818491 0.633668 0.00851068 0.719784 0.050887H0.720784Z"
      fill={color}
      className={className}
    />
  </svg>
);

export const SendIconUpdated: FC<IIcon> = ({
  width = 17,
  height = 17,
  className = "",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9387_21703)">
      <path
        d="M15.8542 0.146028C15.9234 0.21536 15.9707 0.303502 15.9903 0.399505C16.0098 0.495508 16.0008 0.595141 15.9642 0.686028L10.1452 15.233C10.0939 15.3611 10.0083 15.4726 9.89771 15.5552C9.78715 15.6378 9.65596 15.6883 9.51856 15.7011C9.38116 15.7139 9.2429 15.6886 9.11897 15.6279C8.99505 15.5672 8.89027 15.4734 8.81618 15.357L5.63818 10.362L0.643176 7.18403C0.526494 7.11001 0.432527 7.0052 0.371646 6.88116C0.310764 6.75711 0.285334 6.61866 0.298161 6.48108C0.310988 6.3435 0.361574 6.21214 0.444337 6.10148C0.5271 5.99083 0.638822 5.9052 0.767176 5.85403L15.3142 0.0370277C15.4051 0.000439957 15.5047 -0.00863977 15.6007 0.0109164C15.6967 0.0304726 15.7848 0.0778028 15.8542 0.147028V0.146028ZM6.63618 10.07L9.39718 14.408L14.1302 2.57603L6.63618 10.07ZM13.4232 1.86903L1.59118 6.60203L5.93018 9.36203L13.4242 1.86903H13.4232Z"
        fill={color}
        className={className}
      />
    </g>
    <defs>
      <clipPath id="clip0_9387_21703">
        <rect width={width} height={height} fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export const ReloadIcon: FC<IIcon> = ({
  width = 17,
  height = 17,
  className = "",
  color = "white",
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="6" fill="#7697A8" />
    <path
      d="M21.6498 10.35C20.9097 9.60485 20.0294 9.01356 19.0597 8.61023C18.09 8.2069 17.05 7.99951 15.9998 8C11.5798 8 8.00977 11.58 8.00977 16C8.00977 20.42 11.5798 24 15.9998 24C19.7298 24 22.8398 21.45 23.7298 18H21.6498C21.2378 19.1695 20.4731 20.1824 19.4611 20.8988C18.4491 21.6153 17.2397 22 15.9998 22C12.6898 22 9.99977 19.31 9.99977 16C9.99977 12.69 12.6898 10 15.9998 10C17.6598 10 19.1398 10.69 20.2198 11.78L16.9998 15H23.9998V8L21.6498 10.35Z"
      fill="white"
    />
  </svg>
);

export const SearchIcon: FC<IIcon> = ({
  width = 24,
  height = 24,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      opacity="0.3"
      d="M14.2929 16.7071C13.9024 16.3166 13.9024 15.6834 14.2929 15.2929C14.6834 14.9024 15.3166 14.9024 15.7071 15.2929L19.7071 19.2929C20.0976 19.6834 20.0976 20.3166 19.7071 20.7071C19.3166 21.0976 18.6834 21.0976 18.2929 20.7071L14.2929 16.7071Z"
      fill="#858795"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11ZM16 11C16 13.7614 13.7614 16 11 16C8.23858 16 6 13.7614 6 11C6 8.23858 8.23858 6 11 6C13.7614 6 16 8.23858 16 11Z"
      fill="#858795"
    />
  </svg>
);

export const HorizontalGridIcon: FC<IIcon> = ({
  width = 13,
  height = 13,
  className = "",
  isActive = false,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 13"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4184 1.25178C11.0594 1.30722 11.5586 1.78858 11.6459 2.42603C11.696 2.79164 11.7373 3.18876 11.7373 3.50317C11.7373 3.81759 11.696 4.21471 11.6459 4.58032C11.5586 5.21777 11.0594 5.69913 10.4184 5.75457C9.62664 5.82304 8.34413 5.8938 6.4248 5.8938C4.50548 5.8938 3.22297 5.82304 2.4312 5.75456C1.79019 5.69913 1.29103 5.21776 1.20373 4.58032C1.15366 4.21471 1.1123 3.81759 1.1123 3.50317C1.1123 3.18876 1.15366 2.79164 1.20373 2.42603C1.29103 1.78858 1.7902 1.30722 2.4312 1.25178C3.22297 1.18331 4.50548 1.11255 6.4248 1.11255C8.34413 1.11255 9.62664 1.18331 10.4184 1.25178Z"
      fill={isActive ? "#3699FF" : "#959CB6"}
    />
    <path
      d="M10.4184 7.09553C11.0594 7.15097 11.5586 7.63233 11.6459 8.26978C11.696 8.63539 11.7373 9.03251 11.7373 9.34692C11.7373 9.66134 11.696 10.0585 11.6459 10.4241C11.5586 11.0615 11.0594 11.5429 10.4184 11.5983C9.62664 11.6668 8.34413 11.7375 6.4248 11.7375C4.50548 11.7375 3.22297 11.6668 2.4312 11.5983C1.79019 11.5429 1.29103 11.0615 1.20373 10.4241C1.15366 10.0585 1.1123 9.66134 1.1123 9.34692C1.1123 9.03251 1.15366 8.63539 1.20373 8.26978C1.29103 7.63233 1.7902 7.15097 2.4312 7.09553C3.22297 7.02706 4.50548 6.9563 6.4248 6.9563C8.34413 6.9563 9.62664 7.02706 10.4184 7.09553Z"
      fill={isActive ? "#BEDCFA" : "#DFE1E7"}
    />
  </svg>
);

export const GridLayoutIcon: FC<IIcon> = ({
  width = 22,
  height = 22,
  className = "",
  isActive = false,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4.43164"
      y="4.43188"
      width="6.08523"
      height="6.08523"
      rx="1.5"
      fill={isActive ? "#3699FF" : "#858795"}
    />
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2559 5.93189C12.2559 5.10346 12.9274 4.43188 13.7559 4.43188H16.8411C17.6695 4.43188 18.3411 5.10346 18.3411 5.93188V9.01711C18.3411 9.84554 17.6695 10.5171 16.8411 10.5171H13.7559C12.9274 10.5171 12.2559 9.84554 12.2559 9.01711V5.93189ZM4.43164 13.7557C4.43164 12.9273 5.10321 12.2557 5.93164 12.2557H9.01687C9.84529 12.2557 10.5169 12.9273 10.5169 13.7557V16.841C10.5169 17.6694 9.84529 18.341 9.01687 18.341H5.93164C5.10322 18.341 4.43164 17.6694 4.43164 16.841V13.7557ZM13.7559 12.2559C12.9274 12.2559 12.2559 12.9274 12.2559 13.7559V16.8411C12.2559 17.6695 12.9274 18.3411 13.7559 18.3411H16.8411C17.6695 18.3411 18.3411 17.6695 18.3411 16.8411V13.7559C18.3411 12.9274 17.6695 12.2559 16.8411 12.2559H13.7559Z"
      fill={isActive ? "#BEDCFA" : "#C4C4C4"}
    />
  </svg>
);

export const DownloadIcon: FC<IIcon> = ({
  width = 12,
  height = 14,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 14"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 4.75H8.25V0.25H3.75V4.75H0.75L6 10.75L11.25 4.75ZM0 12.25H12V13.75H0V12.25Z"
      className="fill-white group-hover:fill-black2 transition-all duration-300"
    />
  </svg>
);

export const ViewIcon: FC<IIcon> = ({
  width = 16,
  height = 12,
  className = "",
  color = "#8950FC",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 6C16 6 13 0.5 8 0.5C3 0.5 0 6 0 6C0 6 3 11.5 8 11.5C13 11.5 16 6 16 6ZM1.173 6C1.65651 5.26512 2.21264 4.58069 2.833 3.957C4.12 2.668 5.88 1.5 8 1.5C10.12 1.5 11.879 2.668 13.168 3.957C13.7884 4.58069 14.3445 5.26512 14.828 6C14.77 6.087 14.706 6.183 14.633 6.288C14.298 6.768 13.803 7.408 13.168 8.043C11.879 9.332 10.119 10.5 8 10.5C5.88 10.5 4.121 9.332 2.832 8.043C2.21165 7.41931 1.65552 6.73487 1.172 6H1.173Z"
      className="fill-white group-hover:fill-[#8950FC]"
    />
    <path
      d="M8 3.5C7.33696 3.5 6.70107 3.76339 6.23223 4.23223C5.76339 4.70107 5.5 5.33696 5.5 6C5.5 6.66304 5.76339 7.29893 6.23223 7.76777C6.70107 8.23661 7.33696 8.5 8 8.5C8.66304 8.5 9.29893 8.23661 9.76777 7.76777C10.2366 7.29893 10.5 6.66304 10.5 6C10.5 5.33696 10.2366 4.70107 9.76777 4.23223C9.29893 3.76339 8.66304 3.5 8 3.5ZM4.5 6C4.5 5.07174 4.86875 4.1815 5.52513 3.52513C6.1815 2.86875 7.07174 2.5 8 2.5C8.92826 2.5 9.8185 2.86875 10.4749 3.52513C11.1313 4.1815 11.5 5.07174 11.5 6C11.5 6.92826 11.1313 7.8185 10.4749 8.47487C9.8185 9.13125 8.92826 9.5 8 9.5C7.07174 9.5 6.1815 9.13125 5.52513 8.47487C4.86875 7.8185 4.5 6.92826 4.5 6Z"
      className="fill-white group-hover:fill-[#8950FC]"
    />
  </svg>
);

export const GenerateIcon: FC<IIcon> = ({
  width = 16,
  height = 12,
  className = "",
  color = "#8950FC",
}) => (
  // <svg
  //   width={width}
  //   height={height}
  //   className={className}
  //   viewBox="0 0 16 12"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <path
  //     d="M16 6C16 6 13 0.5 8 0.5C3 0.5 0 6 0 6C0 6 3 11.5 8 11.5C13 11.5 16 6 16 6ZM1.173 6C1.65651 5.26512 2.21264 4.58069 2.833 3.957C4.12 2.668 5.88 1.5 8 1.5C10.12 1.5 11.879 2.668 13.168 3.957C13.7884 4.58069 14.3445 5.26512 14.828 6C14.77 6.087 14.706 6.183 14.633 6.288C14.298 6.768 13.803 7.408 13.168 8.043C11.879 9.332 10.119 10.5 8 10.5C5.88 10.5 4.121 9.332 2.832 8.043C2.21165 7.41931 1.65552 6.73487 1.172 6H1.173Z"
  //     className="fill-white group-hover:fill-[#8950FC]"
  //   />
  //   <path
  //     d="M8 3.5C7.33696 3.5 6.70107 3.76339 6.23223 4.23223C5.76339 4.70107 5.5 5.33696 5.5 6C5.5 6.66304 5.76339 7.29893 6.23223 7.76777C6.70107 8.23661 7.33696 8.5 8 8.5C8.66304 8.5 9.29893 8.23661 9.76777 7.76777C10.2366 7.29893 10.5 6.66304 10.5 6C10.5 5.33696 10.2366 4.70107 9.76777 4.23223C9.29893 3.76339 8.66304 3.5 8 3.5ZM4.5 6C4.5 5.07174 4.86875 4.1815 5.52513 3.52513C6.1815 2.86875 7.07174 2.5 8 2.5C8.92826 2.5 9.8185 2.86875 10.4749 3.52513C11.1313 4.1815 11.5 5.07174 11.5 6C11.5 6.92826 11.1313 7.8185 10.4749 8.47487C9.8185 9.13125 8.92826 9.5 8 9.5C7.07174 9.5 6.1815 9.13125 5.52513 8.47487C4.86875 7.8185 4.5 6.92826 4.5 6Z"
  //     className="fill-white group-hover:fill-[#8950FC]"
  //   />
  // </svg>

  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10019_1392)">
      <path
        d="M10.8891 1.55554H5.78299L3.11133 4.22332V5.83332H3.88911V5.29276H6.84855V2.33332H10.8891V11.6667H3.11133C3.11133 11.8729 3.19327 12.0708 3.33913 12.2166C3.485 12.3625 3.68283 12.4444 3.88911 12.4444H10.8891C11.0954 12.4444 11.2932 12.3625 11.4391 12.2166C11.5849 12.0708 11.6669 11.8729 11.6669 11.6667V2.33332C11.6669 2.12704 11.5849 1.92921 11.4391 1.78335C11.2932 1.63749 11.0954 1.55554 10.8891 1.55554ZM6.22244 4.66665H3.88911V4.54221L6.10577 2.33332H6.22244V4.66665Z"
        fill="#464E5F"
      />
      <path
        d="M4.6429 10.22C4.60219 10.2549 4.56913 10.2978 4.54578 10.346C4.52244 10.3943 4.50932 10.4468 4.50726 10.5004C4.50519 10.5539 4.51421 10.6074 4.53376 10.6573C4.55331 10.7072 4.58297 10.7525 4.62087 10.7904C4.65877 10.8283 4.70409 10.8579 4.754 10.8775C4.8039 10.897 4.85731 10.9061 4.91086 10.904C4.96442 10.9019 5.01697 10.8888 5.06522 10.8655C5.11347 10.8421 5.15637 10.8091 5.19123 10.7684L7.38845 8.55557L5.17957 6.34669C5.10517 6.28297 5.00948 6.24968 4.9116 6.25346C4.81373 6.25724 4.72088 6.29782 4.65162 6.36708C4.58237 6.43634 4.54179 6.52918 4.53801 6.62705C4.53423 6.72493 4.56752 6.82062 4.63123 6.89502L5.91068 8.16669H1.16623C1.06309 8.16669 0.964177 8.20766 0.891247 8.28059C0.818316 8.35352 0.777344 8.45243 0.777344 8.55557C0.777344 8.65871 0.818316 8.75763 0.891247 8.83056C0.964177 8.90349 1.06309 8.94446 1.16623 8.94446H5.92234L4.6429 10.22Z"
        fill="#464E5F"
      />
    </g>
    <defs>
      <clipPath id="clip0_10019_1392">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StarIcon: FC<IIcon> = ({
  width = 20,
  height = 19,
  className = "",
  color = "#F3F6F9",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 19"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.825 19L5.45 11.975L0 7.25L7.2 6.625L10 0L12.8 6.625L20 7.25L14.55 11.975L16.175 19L10 15.275L3.825 19Z"
      fill={color}
    />
  </svg>
);

export const DraggableIcon: FC<IIcon> = ({
  width = 7,
  height = 30,
  className = "",
  color = "#C4C4C4",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 7 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="1.16667" cy="1.15385" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="5.83268" cy="1.15385" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="1.16667" cy="5.76908" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="5.83268" cy="5.76908" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="1.16667" cy="10.3848" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="5.83268" cy="10.3848" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="1.16667" cy="15" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="5.83268" cy="15" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="1.16667" cy="19.6153" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="5.83268" cy="19.6153" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="1.16667" cy="24.231" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="1.16667" cy="28.8462" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="5.83268" cy="24.231" rx="1.16667" ry="1.15385" fill={color} />
    <ellipse cx="5.83268" cy="28.8462" rx="1.16667" ry="1.15385" fill={color} />
  </svg>
);

export const FolderIcon: FC<IIcon> = ({
  width = 24,
  height = 24,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 6H11L9 4H4C2.9 4 2 4.9 2 6V10H22V8C22 6.9 21.1 6 20 6Z"
      fill="#FFA000"
    />
    <path
      d="M20 6H4C2.9 6 2 6.9 2 8V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6Z"
      fill="#FFCA28"
    />
  </svg>
);

export const WeatherIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3333 8C11.3333 9.84095 9.84095 11.3333 8 11.3333C6.15905 11.3333 4.66667 9.84095 4.66667 8C4.66667 6.15905 6.15905 4.66667 8 4.66667C9.84095 4.66667 11.3333 6.15905 11.3333 8Z"
      fill="#464E5F"
    />
    <path
      d="M8 11C7.20435 11 6.44129 10.6839 5.87868 10.1213C5.31607 9.55871 5 8.79565 5 8C5 7.20435 5.31607 6.44129 5.87868 5.87868C6.44129 5.31607 7.20435 5 8 5C8.79565 5 9.55871 5.31607 10.1213 5.87868C10.6839 6.44129 11 7.20435 11 8C11 8.79565 10.6839 9.55871 10.1213 10.1213C9.55871 10.6839 8.79565 11 8 11ZM8 12C9.06087 12 10.0783 11.5786 10.8284 10.8284C11.5786 10.0783 12 9.06087 12 8C12 6.93913 11.5786 5.92172 10.8284 5.17157C10.0783 4.42143 9.06087 4 8 4C6.93913 4 5.92172 4.42143 5.17157 5.17157C4.42143 5.92172 4 6.93913 4 8C4 9.06087 4.42143 10.0783 5.17157 10.8284C5.92172 11.5786 6.93913 12 8 12ZM8 0C8.13261 0 8.25979 0.0526784 8.35355 0.146447C8.44732 0.240215 8.5 0.367392 8.5 0.5V2.5C8.5 2.63261 8.44732 2.75978 8.35355 2.85355C8.25979 2.94732 8.13261 3 8 3C7.86739 3 7.74022 2.94732 7.64645 2.85355C7.55268 2.75978 7.5 2.63261 7.5 2.5V0.5C7.5 0.367392 7.55268 0.240215 7.64645 0.146447C7.74022 0.0526784 7.86739 0 8 0ZM8 13C8.13261 13 8.25979 13.0527 8.35355 13.1464C8.44732 13.2402 8.5 13.3674 8.5 13.5V15.5C8.5 15.6326 8.44732 15.7598 8.35355 15.8536C8.25979 15.9473 8.13261 16 8 16C7.86739 16 7.74022 15.9473 7.64645 15.8536C7.55268 15.7598 7.5 15.6326 7.5 15.5V13.5C7.5 13.3674 7.55268 13.2402 7.64645 13.1464C7.74022 13.0527 7.86739 13 8 13ZM16 8C16 8.13261 15.9473 8.25979 15.8536 8.35355C15.7598 8.44732 15.6326 8.5 15.5 8.5H13.5C13.3674 8.5 13.2402 8.44732 13.1464 8.35355C13.0527 8.25979 13 8.13261 13 8C13 7.86739 13.0527 7.74022 13.1464 7.64645C13.2402 7.55268 13.3674 7.5 13.5 7.5H15.5C15.6326 7.5 15.7598 7.55268 15.8536 7.64645C15.9473 7.74022 16 7.86739 16 8ZM3 8C3 8.13261 2.94732 8.25979 2.85355 8.35355C2.75978 8.44732 2.63261 8.5 2.5 8.5H0.5C0.367392 8.5 0.240215 8.44732 0.146447 8.35355C0.0526784 8.25979 0 8.13261 0 8C0 7.86739 0.0526784 7.74022 0.146447 7.64645C0.240215 7.55268 0.367392 7.5 0.5 7.5H2.5C2.63261 7.5 2.75978 7.55268 2.85355 7.64645C2.94732 7.74022 3 7.86739 3 8ZM13.657 2.343C13.7507 2.43676 13.8034 2.56392 13.8034 2.6965C13.8034 2.82908 13.7507 2.95624 13.657 3.05L12.243 4.465C12.1965 4.51142 12.1413 4.54823 12.0806 4.57333C12.0199 4.59843 11.9548 4.61132 11.8891 4.61128C11.7565 4.61118 11.6293 4.55839 11.5355 4.4645C11.4891 4.41801 11.4523 4.36284 11.4272 4.30212C11.4021 4.24141 11.3892 4.17634 11.3892 4.11065C11.3893 3.97796 11.4421 3.85075 11.536 3.757L12.95 2.343C13.0438 2.24926 13.1709 2.19661 13.3035 2.19661C13.4361 2.19661 13.5632 2.24926 13.657 2.343ZM4.464 11.536C4.55774 11.6298 4.61039 11.7569 4.61039 11.8895C4.61039 12.0221 4.55774 12.1492 4.464 12.243L3.05 13.657C2.9557 13.7481 2.8294 13.7985 2.6983 13.7973C2.5672 13.7962 2.4418 13.7436 2.34909 13.6509C2.25639 13.5582 2.2038 13.4328 2.20266 13.3017C2.20152 13.1706 2.25192 13.0443 2.343 12.95L3.757 11.536C3.85076 11.4423 3.97792 11.3896 4.1105 11.3896C4.24308 11.3896 4.37024 11.4423 4.464 11.536ZM13.657 13.657C13.5632 13.7507 13.4361 13.8034 13.3035 13.8034C13.1709 13.8034 13.0438 13.7507 12.95 13.657L11.536 12.243C11.4449 12.1487 11.3945 12.0224 11.3957 11.8913C11.3968 11.7602 11.4494 11.6348 11.5421 11.5421C11.6348 11.4494 11.7602 11.3968 11.8913 11.3957C12.0224 11.3945 12.1487 11.4449 12.243 11.536L13.657 12.95C13.7507 13.0438 13.8034 13.1709 13.8034 13.3035C13.8034 13.4361 13.7507 13.5632 13.657 13.657ZM4.464 4.465C4.37024 4.55874 4.24308 4.61139 4.1105 4.61139C3.97792 4.61139 3.85076 4.55874 3.757 4.465L2.343 3.05C2.29524 3.00388 2.25715 2.9487 2.23095 2.8877C2.20475 2.8267 2.19095 2.76109 2.19037 2.6947C2.1898 2.62831 2.20245 2.56247 2.22759 2.50102C2.25273 2.43957 2.28986 2.38375 2.3368 2.3368C2.38375 2.28986 2.43957 2.25273 2.50102 2.22759C2.56247 2.20245 2.62831 2.1898 2.6947 2.19037C2.76109 2.19095 2.8267 2.20475 2.8877 2.23095C2.9487 2.25715 3.00388 2.29524 3.05 2.343L4.464 3.757C4.51056 3.80345 4.54751 3.85862 4.57271 3.91937C4.59792 3.98011 4.61089 4.04523 4.61089 4.111C4.61089 4.17677 4.59792 4.24189 4.57271 4.30263C4.54751 4.36338 4.51056 4.41855 4.464 4.465Z"
      fill="#464E5F"
    />
  </svg>
);

export const ClockInIcon: FC<IIcon> = ({
  width = 18,
  height = 21,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.02628 0.724121L0.724609 2.02579L4.40044 5.69245L2.75044 7.33329H7.33378V2.74995L5.69294 4.39995M11.0004 7.33329C7.46211 7.33329 4.58378 10.2025 4.58378 13.75C4.58378 15.4518 5.25982 17.0839 6.46317 18.2872C7.66653 19.4906 9.29864 20.1666 11.0004 20.1666C14.5388 20.1666 17.4171 17.2975 17.4171 13.75C17.4171 12.0481 16.7411 10.416 15.5377 9.21269C14.3344 8.00933 12.7022 7.33329 11.0004 7.33329M11.0004 9.30412C13.4479 9.30412 15.4463 11.2933 15.4463 13.75C15.4463 14.3338 15.3313 14.9119 15.1079 15.4513C14.8844 15.9907 14.557 16.4808 14.1441 16.8936C13.7313 17.3065 13.2412 17.6339 12.7018 17.8574C12.1624 18.0808 11.5843 18.1958 11.0004 18.1958C8.54378 18.1958 6.55461 16.2066 6.55461 13.75C6.55461 12.5708 7.02301 11.44 7.85676 10.6063C8.69052 9.77252 9.82133 9.30412 11.0004 9.30412M10.0838 11V14.3825L13.0079 16.0691L13.6954 14.8775L11.4588 13.585V11"
      fill="white"
    />
  </svg>
);

export const ClockOutIcon: FC<IIcon> = ({
  width = 24,
  height = 24,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 1L19.8 2.79L15.79 6.79L17.21 8.21L21.21 4.21L23 6V1M12 8C8.14 8 5 11.13 5 15C5 16.8565 5.7375 18.637 7.05025 19.9497C8.36301 21.2625 10.1435 22 12 22C15.86 22 19 18.87 19 15C19 13.1435 18.2625 11.363 16.9497 10.0503C15.637 8.7375 13.8565 8 12 8ZM12 10.15C14.67 10.15 16.85 12.32 16.85 15C16.85 15.6369 16.7246 16.2676 16.4808 16.856C16.2371 17.4444 15.8798 17.9791 15.4295 18.4295C14.9791 18.8798 14.4444 19.2371 13.856 19.4808C13.2676 19.7246 12.6369 19.85 12 19.85C9.32 19.85 7.15 17.68 7.15 15C7.15 13.7137 7.66098 12.4801 8.57053 11.5705C9.48008 10.661 10.7137 10.15 12 10.15ZM11 12V15.69L14.19 17.53L14.94 16.23L12.5 14.82V12"
      fill="white"
    />
  </svg>
);

export const LoadingIcon: FC<IIcon> = ({
  width = 22,
  height = 22,
  className = "",
  color="#fff"
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.001 11.0004C22.001 17.0755 17.0761 22.0004 11.001 22.0004C4.92583 22.0004 0.000959396 17.0755 0.000959396 11.0004C0.000959396 4.92524 4.92583 0.000375748 11.001 0.000375748C17.0761 0.000375748 22.001 4.92524 22.001 11.0004ZM2.57265 11.0004C2.57265 15.6552 6.34613 19.4287 11.001 19.4287C15.6558 19.4287 19.4293 15.6552 19.4293 11.0004C19.4293 6.34555 15.6558 2.57207 11.001 2.57207C6.34613 2.57207 2.57265 6.34555 2.57265 11.0004Z"
      fill="url(#paint0_angular_1_34)"
    />
    <ellipse cx="10.9633" cy="20.7165" rx="1.28333" ry="1.28333" fill={color} />
    <defs>
      <radialGradient
        id="paint0_angular_1_34"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.001 11.0004) rotate(90) scale(11)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const DoneIcon: FC<IIcon> = ({
  width = 16,
  height = 13,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.78125 7.03125L5.59375 11.8438L15.2188 1.53125"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShowIcon: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3886 8.775C17.3675 8.71875 16.7699 7.39688 15.448 6.06797C13.6832 4.31016 11.4543 3.375 9.00034 3.375C6.54644 3.375 4.31753 4.31016 2.55269 6.06797C1.23081 7.39688 0.633157 8.71875 0.612063 8.775C0.580671 8.84586 0.564453 8.9225 0.564453 9C0.564453 9.0775 0.580671 9.15414 0.612063 9.225C0.633157 9.28125 1.23081 10.6031 2.55269 11.932C4.31753 13.6898 6.54644 14.625 9.00034 14.625C11.4543 14.625 13.6832 13.6898 15.448 11.932C16.7699 10.6031 17.3675 9.28125 17.3886 9.225C17.42 9.15414 17.4362 9.0775 17.4362 9C17.4362 8.9225 17.42 8.84586 17.3886 8.775ZM9.00034 13.5C6.83472 13.5 4.94331 12.7125 3.38238 11.1586C2.73728 10.5233 2.18993 9.79584 1.75816 9C2.18934 8.20168 2.73672 7.47184 3.38238 6.83437C4.94331 5.2875 6.83472 4.5 9.00034 4.5C11.166 4.5 13.0574 5.2875 14.6183 6.83437C15.264 7.47184 15.8113 8.20168 16.2425 9C15.7363 9.94922 13.5285 13.5 9.00034 13.5ZM9.00034 5.625C8.33283 5.625 7.68031 5.82294 7.12529 6.19379C6.57028 6.56464 6.1377 7.09174 5.88225 7.70844C5.62681 8.32514 5.55997 9.00374 5.69019 9.65843C5.82042 10.3131 6.14186 10.9145 6.61386 11.3865C7.08586 11.8585 7.68723 12.1799 8.34191 12.3102C8.9966 12.4404 9.6752 12.3735 10.2919 12.1181C10.9086 11.8626 11.4357 11.4301 11.8066 10.875C12.1774 10.32 12.3753 9.66751 12.3753 9C12.3753 8.10489 12.0198 7.24645 11.3868 6.61351C10.7539 5.98058 9.89545 5.625 9.00034 5.625ZM9.00034 11.25C8.55534 11.25 8.12032 11.118 7.75031 10.8708C7.3803 10.6236 7.09191 10.2722 6.92162 9.86104C6.75132 9.4499 6.70676 8.9975 6.79358 8.56105C6.88039 8.12459 7.09469 7.72368 7.40935 7.40901C7.72402 7.09434 8.12493 6.88005 8.56139 6.79323C8.99785 6.70642 9.45025 6.75097 9.86138 6.92127C10.2725 7.09157 10.6239 7.37996 10.8712 7.74997C11.1184 8.11998 11.2503 8.55499 11.2503 9C11.2485 9.59617 11.0108 10.1674 10.5893 10.5889C10.1677 11.0105 9.59651 11.2481 9.00034 11.25Z"
      fill="#858795"
    />
  </svg>
);

export const HiddenIcon: FC<IIcon> = ({
  width = 18,
  height = 14,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.7898 0.432862C3.68817 0.326544 3.54895 0.264257 3.40196 0.259347C3.25496 0.254437 3.11189 0.307294 3.0034 0.406593C2.89491 0.505892 2.82962 0.643734 2.82153 0.790586C2.81344 0.937439 2.86318 1.08162 2.96011 1.19224L4.31011 2.67583C1.75777 4.2438 0.66089 6.66255 0.611672 6.77505C0.580522 6.84721 0.564453 6.92497 0.564453 7.00357C0.564453 7.08216 0.580522 7.15992 0.611672 7.23208C0.632765 7.2813 1.23042 8.60318 2.5523 9.93208C4.31714 11.6899 6.54605 12.625 8.99995 12.625C10.2606 12.6301 11.5084 12.3714 12.6632 11.8657L14.2101 13.5672C14.2628 13.6248 14.3269 13.6708 14.3983 13.7023C14.4697 13.7338 14.5469 13.75 14.625 13.75C14.7653 13.7487 14.9003 13.6962 15.0046 13.6024C15.0599 13.553 15.1048 13.4931 15.1366 13.4262C15.1684 13.3592 15.1864 13.2866 15.1897 13.2125C15.193 13.1385 15.1814 13.0645 15.1556 12.995C15.1299 12.9255 15.0905 12.8619 15.0398 12.8079L3.7898 0.432862ZM7.11558 5.76958L10.0476 8.98989C9.72509 9.16142 9.36525 9.25077 8.99995 9.25005C8.59444 9.25017 8.19643 9.14069 7.84802 8.93319C7.49962 8.7257 7.21376 8.4279 7.02069 8.0713C6.82762 7.7147 6.73452 7.31255 6.75122 6.90738C6.76792 6.50221 6.89381 6.10908 7.11558 5.76958ZM8.99995 11.5C6.83433 11.5 4.94292 10.7126 3.38198 9.15864C2.7353 8.52471 2.18776 7.79703 1.75777 7.00005C2.08823 6.3813 3.14995 4.64458 5.08355 3.52661L6.34917 4.9188C5.86133 5.54619 5.61053 6.32561 5.64096 7.11977C5.6714 7.91393 5.98111 8.67187 6.51554 9.26008C7.04998 9.8483 7.77485 10.229 8.56246 10.3353C9.35007 10.4415 10.1499 10.2663 10.821 9.84067L11.8546 10.9797C10.9435 11.3283 9.97552 11.5048 8.99995 11.5ZM17.3882 7.23208C17.3601 7.29536 16.65 8.87036 15.0398 10.3118C14.9366 10.402 14.8042 10.4519 14.6671 10.4524C14.5883 10.4533 14.5102 10.4368 14.4384 10.404C14.3667 10.3711 14.3031 10.3228 14.2523 10.2625C14.2029 10.2076 14.1648 10.1435 14.1402 10.0738C14.1155 10.0042 14.1049 9.93033 14.1088 9.85654C14.1127 9.78276 14.1311 9.71047 14.163 9.64381C14.1948 9.57714 14.2395 9.51741 14.2945 9.46802C15.0803 8.76306 15.7392 7.92824 16.2421 7.00005C15.811 6.20173 15.2636 5.47189 14.6179 4.83442C13.057 3.28755 11.1656 2.50005 8.99995 2.50005C8.54287 2.49821 8.08649 2.53585 7.63589 2.61255C7.48882 2.63502 7.33879 2.59904 7.2179 2.51232C7.09701 2.42559 7.01486 2.295 6.98902 2.14849C6.97695 2.07554 6.97939 2.00092 6.99619 1.92891C7.01299 1.8569 7.04383 1.78891 7.08693 1.72883C7.13003 1.66875 7.18455 1.61776 7.24738 1.57877C7.31021 1.53978 7.38011 1.51356 7.45308 1.50161C7.96428 1.41644 8.4817 1.37411 8.99995 1.37505C11.4539 1.37505 13.6828 2.31021 15.4476 4.06802C16.7695 5.39692 17.3671 6.7188 17.3882 6.77505C17.4194 6.84721 17.4355 6.92497 17.4355 7.00357C17.4355 7.08216 17.4194 7.15992 17.3882 7.23208ZM9.42183 4.79224C9.34888 4.77839 9.27938 4.7503 9.21729 4.70959C9.1552 4.66888 9.10173 4.61634 9.05994 4.55497C8.97555 4.43102 8.94386 4.27862 8.97183 4.1313C8.9998 3.98398 9.08515 3.85381 9.2091 3.76942C9.33305 3.68502 9.48545 3.65333 9.63277 3.6813C10.35 3.82158 11.0029 4.18949 11.4944 4.73038C11.9859 5.27127 12.2897 5.95628 12.3609 6.68364C12.3746 6.83184 12.329 6.97942 12.2341 7.09408C12.1392 7.20873 12.0028 7.28111 11.8546 7.29536H11.7984C11.6592 7.29591 11.5249 7.24419 11.422 7.15044C11.3192 7.05669 11.2553 6.92774 11.2429 6.78911C11.1944 6.30471 10.991 5.84886 10.663 5.48915C10.335 5.12945 9.89972 4.88506 9.42183 4.79224Z"
      fill="#B5B5C3"
    />
  </svg>
);

export const CopyClipIcon: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9466 1.21533H5.45502C4.44455 1.21533 3.62251 2.03984 3.62251 3.05336V3.62244H3.04736C2.03688 3.62244 1.21484 4.44695 1.21484 5.46103V14.9472C1.21484 15.9607 2.03688 16.7852 3.04736 16.7852H12.5393C13.553 16.7852 14.3776 15.9607 14.3776 14.9472V14.3781H14.9466C15.9604 14.3781 16.7852 13.5536 16.7852 12.5395V3.0533C16.7852 2.03984 15.9604 1.21533 14.9466 1.21533ZM13.2526 14.9471C13.2526 15.3404 12.9326 15.6602 12.5393 15.6602H3.04736C2.65732 15.6602 2.33984 15.3404 2.33984 14.9471V5.46097C2.33984 5.06767 2.65738 4.74738 3.04736 4.74738H4.18501H12.5393C12.9326 4.74738 13.2526 5.06761 13.2526 5.46097V13.8155V14.9471ZM15.6602 12.5395C15.6602 12.9328 15.3402 13.2531 14.9466 13.2531H14.3775V5.46097C14.3775 4.44695 13.553 3.62238 12.5392 3.62238H4.74746V3.0533C4.74746 2.66 5.06499 2.34028 5.45497 2.34028H14.9466C15.3402 2.34028 15.6602 2.66 15.6602 3.0533V12.5395Z"
      fill="#858795"
    />
  </svg>
);

export const TrashIcon: FC<IIcon> = ({
  width = 14,
  height = 15,
  className = "",
  hasHoverState = true,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 1C0.947715 1 0.5 1.44772 0.5 2V3C0.5 3.55228 0.947715 4 1.5 4H2V13C2 14.1046 2.89543 15 4 15H10C11.1046 15 12 14.1046 12 13V4H12.5C13.0523 4 13.5 3.55228 13.5 3V2C13.5 1.44772 13.0523 1 12.5 1H9C9 0.447715 8.55229 0 8 0H6C5.44772 0 5 0.447715 5 1H1.5ZM4.5 5C4.77614 5 5 5.22386 5 5.5V12.5C5 12.7761 4.77614 13 4.5 13C4.22386 13 4 12.7761 4 12.5L4 5.5C4 5.22386 4.22386 5 4.5 5ZM7 5C7.27614 5 7.5 5.22386 7.5 5.5V12.5C7.5 12.7761 7.27614 13 7 13C6.72386 13 6.5 12.7761 6.5 12.5V5.5C6.5 5.22386 6.72386 5 7 5ZM10 5.5V12.5C10 12.7761 9.77614 13 9.5 13C9.22386 13 9 12.7761 9 12.5V5.5C9 5.22386 9.22386 5 9.5 5C9.77614 5 10 5.22386 10 5.5Z"
      className={`fill-white transition-all duration-300 ${
        hasHoverState ? "group-hover:fill-redPink" : ""
      }`}
    />
  </svg>
);

export const EditIcon: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.241 1.50977L16.491 3.75977L14.7758 5.47577L12.5258 3.22577L14.241 1.50977ZM6 12.0008H8.25L13.7153 6.53552L11.4653 4.28552L6 9.75077V12.0008Z"
      className="fill-white group-hover:fill-vorpblue transition-all duration-300"
    />
    <path
      d="M14.25 14.25H6.1185C6.099 14.25 6.07875 14.2575 6.05925 14.2575C6.0345 14.2575 6.00975 14.2508 5.98425 14.25H3.75V3.75H8.88525L10.3853 2.25H3.75C2.92275 2.25 2.25 2.922 2.25 3.75V14.25C2.25 15.078 2.92275 15.75 3.75 15.75H14.25C14.6478 15.75 15.0294 15.592 15.3107 15.3107C15.592 15.0294 15.75 14.6478 15.75 14.25V7.749L14.25 9.249V14.25Z"
      className="fill-white group-hover:fill-vorpblue transition-all duration-300"
    />
  </svg>
);

export const AttachIcon: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.954102"
      y="0.5"
      width="28"
      height="28"
      rx="5.25"
      fill="#FFE3AC"
    />
    <path
      d="M16.3296 13.055L16.4241 13.0876C16.452 13.0067 16.4638 12.9211 16.4587 12.8356C16.4535 12.7502 16.4316 12.6666 16.3942 12.5896L16.3042 12.6333L16.3942 12.5896C16.3567 12.5126 16.3045 12.4437 16.2404 12.3869C15.4864 11.717 14.5049 11.3605 13.4967 11.3905C12.4885 11.4204 11.5299 11.8345 10.8169 12.548C10.8169 12.548 10.8169 12.548 10.8169 12.548L9.15691 14.208C8.41467 14.9498 7.9975 15.956 7.99717 17.0054C7.99684 18.0547 8.41337 19.0612 9.15514 19.8034C9.89691 20.5457 10.9031 20.9628 11.9525 20.9632C13.0018 20.9635 14.0083 20.547 14.7506 19.8052L14.7508 19.805L15.4347 19.1169C15.4348 19.1169 15.4348 19.1168 15.4349 19.1168C15.5567 18.9948 15.6252 18.8294 15.6252 18.657C15.6252 18.4846 15.5567 18.3191 15.4348 18.1971C15.4348 18.1971 15.4348 18.1971 15.4347 18.1971L15.364 18.2678C15.3129 18.2166 15.2522 18.176 15.1853 18.1483M16.3296 13.055L15.1853 18.1483M16.3296 13.055L16.4241 13.0876C16.3961 13.1685 16.3525 13.2431 16.2957 13.3072C16.2389 13.3713 16.1701 13.4235 16.0931 13.4609C16.0161 13.4984 15.9325 13.5203 15.847 13.5254C15.7616 13.5306 15.6759 13.5188 15.595 13.4909C15.5141 13.4629 15.4395 13.4193 15.3754 13.3625L15.3754 13.3624C14.8695 12.9132 14.2112 12.6742 13.535 12.6943C12.8587 12.7144 12.2157 12.9921 11.7375 13.4705L11.7374 13.4706L10.0774 15.1285C9.57976 15.6262 9.30019 16.3011 9.30019 17.0049C9.30019 17.7086 9.57976 18.3836 10.0774 18.8812C10.575 19.3789 11.25 19.6584 11.9537 19.6584C12.6575 19.6584 13.3324 19.3789 13.8301 18.8812L14.5142 18.1971C14.5142 18.1971 14.5142 18.1971 14.5142 18.1971C14.5746 18.1366 14.6464 18.0887 14.7253 18.0559L14.7636 18.1483M16.3296 13.055L14.7636 18.1483M15.1853 18.1483L15.2236 18.0559C15.1446 18.0232 15.06 18.0063 14.9745 18.0063C14.889 18.0063 14.8043 18.0232 14.7253 18.0559L14.7636 18.1483M15.1853 18.1483H14.7636M20.2873 8.73031V8.72851L20.2579 8.6992C19.5156 7.95854 18.5097 7.54258 17.4611 7.54258C16.4125 7.54258 15.4067 7.95854 14.6643 8.6992L14.6642 8.69932L13.9801 9.38412C13.9801 9.38412 13.9801 9.38412 13.9801 9.38413C13.8581 9.5062 13.7896 9.67173 13.7897 9.84429C13.7898 10.0169 13.8584 10.1823 13.9805 10.3043C14.1026 10.4263 14.2681 10.4947 14.4407 10.4947C14.6132 10.4946 14.7787 10.426 14.9007 10.3039L15.5848 9.6198C16.0824 9.12216 16.7573 8.84259 17.4611 8.84259C18.1649 8.84259 18.8398 9.12216 19.3374 9.6198C19.8351 10.1174 20.1147 10.7924 20.1147 11.4961C20.1147 12.1999 19.8351 12.8749 19.3374 13.3725L19.3374 13.3725L17.6774 15.0339C17.1989 15.5121 16.5557 15.7894 15.8795 15.8091C15.2033 15.8288 14.5451 15.5895 14.0395 15.14L14.0394 15.1399C13.91 15.0252 13.7404 14.9666 13.5678 14.977C13.3952 14.9873 13.2338 15.0658 13.1191 15.1952C13.0044 15.3246 12.9458 15.4942 12.9562 15.6668C12.9666 15.8393 13.045 16.0007 13.1743 16.1154C13.9282 16.7855 14.9096 17.1423 15.9178 17.1126C16.926 17.083 17.8848 16.6691 18.5979 15.9558C18.5979 15.9558 18.5979 15.9558 18.5979 15.9558L20.258 14.2958L20.258 14.2957C20.9991 13.5533 21.4154 12.5472 21.4154 11.4982C21.4154 10.4631 21.0101 9.46972 20.2873 8.73031Z"
      fill="#FFA800"
      stroke="#FFA800"
      strokeWidth="0.2"
    />
  </svg>
);

export const TaskListIcon: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25008 11.9167H17.4167C17.6599 11.9167 17.893 12.0132 18.0649 12.1852C18.2368 12.3571 18.3334 12.5902 18.3334 12.8333C18.3334 13.0764 18.2368 13.3096 18.0649 13.4815C17.893 13.6534 17.6599 13.75 17.4167 13.75H8.25008C8.00697 13.75 7.77381 13.6534 7.6019 13.4815C7.42999 13.3096 7.33341 13.0764 7.33341 12.8333C7.33341 12.5902 7.42999 12.3571 7.6019 12.1852C7.77381 12.0132 8.00697 11.9167 8.25008 11.9167ZM8.25008 15.5833H17.4167C17.6599 15.5833 17.893 15.6799 18.0649 15.8518C18.2368 16.0237 18.3334 16.2569 18.3334 16.5C18.3334 16.7431 18.2368 16.9763 18.0649 17.1482C17.893 17.3201 17.6599 17.4167 17.4167 17.4167H8.25008C8.00697 17.4167 7.77381 17.3201 7.6019 17.1482C7.42999 16.9763 7.33341 16.7431 7.33341 16.5C7.33341 16.2569 7.42999 16.0237 7.6019 15.8518C7.77381 15.6799 8.00697 15.5833 8.25008 15.5833ZM13.7501 8.25H17.4167C17.6599 8.25 17.893 8.34658 18.0649 8.51849C18.2368 8.69039 18.3334 8.92355 18.3334 9.16667C18.3334 9.40978 18.2368 9.64294 18.0649 9.81485C17.893 9.98676 17.6599 10.0833 17.4167 10.0833H13.7501C13.507 10.0833 13.2738 9.98676 13.1019 9.81485C12.93 9.64294 12.8334 9.40978 12.8334 9.16667C12.8334 8.92355 12.93 8.69039 13.1019 8.51849C13.2738 8.34658 13.507 8.25 13.7501 8.25ZM7.09783 10.0045L3.66675 6.57433L4.96291 5.27725L7.09783 7.41217L11.7591 2.75L13.0562 4.04617L7.09783 10.0045Z"
      fill="#3699FF"
    />
  </svg>
);

export const UserImageIcon: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 13 12"
    fill="none"
  >
    <path
      d="M6.95422 1C7.61726 1 8.25315 1.26339 8.72199 1.73223C9.19083 2.20107 9.45422 2.83696 9.45422 3.5C9.45422 4.16304 9.19083 4.79893 8.72199 5.26777C8.25315 5.73661 7.61726 6 6.95422 6C6.29118 6 5.6553 5.73661 5.18646 5.26777C4.71762 4.79893 4.45422 4.16304 4.45422 3.5C4.45422 2.83696 4.71762 2.20107 5.18646 1.73223C5.6553 1.26339 6.29118 1 6.95422 1ZM6.95422 7.25C9.71672 7.25 11.9542 8.36875 11.9542 9.75V11H1.95422V9.75C1.95422 8.36875 4.19172 7.25 6.95422 7.25Z"
      fill="#464E5F"
    />
  </svg>
);

export const TopEditButton: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="solar:menu-dots-bold">
      <path
        id="Vector"
        d="M8.00001 4.66667C7.64639 4.66667 7.30725 4.52619 7.0572 4.27614C6.80715 4.02609 6.66668 3.68696 6.66668 3.33333C6.66668 2.97971 6.80715 2.64057 7.0572 2.39052C7.30725 2.14048 7.64639 2 8.00001 2C8.35363 2 8.69277 2.14048 8.94282 2.39052C9.19287 2.64057 9.33334 2.97971 9.33334 3.33333C9.33334 3.68696 9.19287 4.02609 8.94282 4.27614C8.69277 4.52619 8.35363 4.66667 8.00001 4.66667ZM8.00001 9.33333C7.64639 9.33333 7.30725 9.19286 7.0572 8.94281C6.80715 8.69276 6.66668 8.35362 6.66668 8C6.66668 7.64638 6.80715 7.30724 7.0572 7.05719C7.30725 6.80714 7.64639 6.66667 8.00001 6.66667C8.35363 6.66667 8.69277 6.80714 8.94282 7.05719C9.19287 7.30724 9.33334 7.64638 9.33334 8C9.33334 8.35362 9.19287 8.69276 8.94282 8.94281C8.69277 9.19286 8.35363 9.33333 8.00001 9.33333ZM8.00001 14C7.64639 14 7.30725 13.8595 7.0572 13.6095C6.80715 13.3594 6.66668 13.0203 6.66668 12.6667C6.66668 12.313 6.80715 11.9739 7.0572 11.7239C7.30725 11.4738 7.64639 11.3333 8.00001 11.3333C8.35363 11.3333 8.69277 11.4738 8.94282 11.7239C9.19287 11.9739 9.33334 12.313 9.33334 12.6667C9.33334 13.0203 9.19287 13.3594 8.94282 13.6095C8.69277 13.8595 8.35363 14 8.00001 14Z"
        fill="white"
      />
    </g>
  </svg>
);

export const CalendarBoardIcon: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 5H10V9.5C10 9.63261 9.94732 9.75979 9.85355 9.85355C9.75979 9.94732 9.63261 10 9.5 10H0.5C0.367392 10 0.240215 9.94732 0.146447 9.85355C0.0526784 9.75979 0 9.63261 0 9.5V5ZM7.5 1H9.5C9.63261 1 9.75979 1.05268 9.85355 1.14645C9.94732 1.24021 10 1.36739 10 1.5V4H0V1.5C0 1.36739 0.0526784 1.24021 0.146447 1.14645C0.240215 1.05268 0.367392 1 0.5 1H2.5V0H3.5V1H6.5V0H7.5V1Z"
      fill="#464E5F"
    />
  </svg>
);

export const CircleIcon: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9542 5.5C10.9542 8.26154 8.71576 10.5 5.95422 10.5C3.19269 10.5 0.954225 8.26154 0.954225 5.5C0.954225 2.73846 3.19269 0.5 5.95422 0.500001C8.71576 0.500001 10.9542 2.73846 10.9542 5.5ZM5.95422 8.58847C5.85222 8.58847 5.75439 8.54795 5.68226 8.47582C5.61013 8.40369 5.56961 8.30586 5.56961 8.20385L5.56961 4.52608C5.56961 4.42407 5.61013 4.32625 5.68226 4.25412C5.75439 4.18199 5.85222 4.14147 5.95422 4.14147C6.05623 4.14147 6.15406 4.18199 6.22619 4.25412C6.29832 4.32625 6.33884 4.42407 6.33884 4.52608L6.33884 6.07692L6.33884 8.20385C6.33884 8.30586 6.29832 8.40369 6.22619 8.47582C6.15406 8.54795 6.05623 8.58847 5.95422 8.58847ZM5.95422 2.353C5.85222 2.353 5.75439 2.39352 5.68226 2.46565C5.61013 2.53778 5.56961 2.6356 5.56961 2.73761C5.56961 2.83962 5.61013 2.93745 5.68226 3.00957C5.75439 3.0817 5.85222 3.12223 5.95422 3.12223C6.05623 3.12223 6.15406 3.0817 6.22619 3.00957C6.29832 2.93745 6.33884 2.83962 6.33884 2.73761C6.33884 2.6356 6.29832 2.53778 6.22619 2.46565C6.15406 2.39352 6.05623 2.353 5.95422 2.353Z"
      fill="#C4C4C4"
    />
  </svg>
);

export const CancelIcon: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
  color="#fff"
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.125 21.25L20.875 11.125M25.75 16C25.75 21.385 21.385 25.75 16 25.75C10.615 25.75 6.25 21.385 6.25 16C6.25 10.615 10.615 6.25 16 6.25C21.385 6.25 25.75 10.615 25.75 16Z"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="fill-red group-hover:fill-green transition-all duration-300"
    />
  </svg>
);

export const ImportIcon: FC<IIcon> = ({
  width = 14,
  height = 14,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1950_37586)">
      <path
        d="M10.8891 1.55554H5.78299L3.11133 4.22332V5.83332H3.88911V5.29276H6.84855V2.33332H10.8891V11.6667H3.11133C3.11133 11.8729 3.19327 12.0708 3.33913 12.2166C3.485 12.3625 3.68283 12.4444 3.88911 12.4444H10.8891C11.0954 12.4444 11.2932 12.3625 11.4391 12.2166C11.5849 12.0708 11.6669 11.8729 11.6669 11.6667V2.33332C11.6669 2.12704 11.5849 1.92921 11.4391 1.78335C11.2932 1.63749 11.0954 1.55554 10.8891 1.55554ZM6.22244 4.66665H3.88911V4.54221L6.10577 2.33332H6.22244V4.66665Z"
        className="fill-black2 group-hover:fill-vorpblue"
      />
      <path
        d="M4.64339 10.22C4.60268 10.2549 4.56961 10.2978 4.54627 10.346C4.52293 10.3942 4.50981 10.4468 4.50774 10.5004C4.50568 10.5539 4.5147 10.6073 4.53425 10.6572C4.5538 10.7071 4.58346 10.7525 4.62136 10.7904C4.65926 10.8283 4.70458 10.8579 4.75448 10.8775C4.80439 10.897 4.8578 10.906 4.91135 10.904C4.96491 10.9019 5.01746 10.8888 5.06571 10.8654C5.11396 10.8421 5.15686 10.809 5.19172 10.7683L7.38894 8.55554L5.18005 6.34665C5.10566 6.28294 5.00996 6.24965 4.91209 6.25343C4.81422 6.25721 4.72137 6.29779 4.65211 6.36705C4.58285 6.43631 4.54228 6.52915 4.5385 6.62702C4.53472 6.7249 4.56801 6.82059 4.63172 6.89499L5.91117 8.16665H1.16672C1.06358 8.16665 0.964666 8.20763 0.891735 8.28056C0.818804 8.35349 0.777832 8.4524 0.777832 8.55554C0.777832 8.65868 0.818804 8.7576 0.891735 8.83053C0.964666 8.90346 1.06358 8.94443 1.16672 8.94443H5.92283L4.64339 10.22Z"
        className="fill-black2 group-hover:fill-vorpblue"
      />
    </g>
    <defs>
      <clipPath id="clip0_1950_37586">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ExportIcon: FC<IIcon> = ({
  width = 14,
  height = 14,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1950_37605)">
      <path
        d="M2.33344 5.29276H5.29289V2.33332H9.33344V5.59221H10.1112V2.33332C10.1112 2.12704 10.0293 1.92921 9.88341 1.78335C9.73755 1.63749 9.53972 1.55554 9.33344 1.55554H4.22733L1.55566 4.22721V11.6667C1.55566 11.8729 1.63761 12.0708 1.78347 12.2166C1.92933 12.3625 2.12716 12.4444 2.33344 12.4444H9.33344C9.53972 12.4444 9.73755 12.3625 9.88341 12.2166C10.0293 12.0708 10.1112 11.8729 10.1112 11.6667H2.33344V5.29276ZM2.33344 4.5461L4.54622 2.33332H4.66677V4.66665H2.33344V4.5461Z"
        className="group-hover:fill-white fill-vorpblue"
      />
      <path
        d="M11.0136 6.35834C10.9392 6.29463 10.8435 6.26134 10.7456 6.26512C10.6477 6.2689 10.5549 6.30948 10.4856 6.37873C10.4164 6.44799 10.3758 6.54084 10.372 6.63871C10.3682 6.73658 10.4015 6.83228 10.4652 6.90668L11.7291 8.16668H7.00022C6.89708 8.16668 6.79816 8.20765 6.72523 8.28058C6.6523 8.35351 6.61133 8.45243 6.61133 8.55556C6.61133 8.6587 6.6523 8.75762 6.72523 8.83055C6.79816 8.90348 6.89708 8.94445 7.00022 8.94445H11.7408L10.4652 10.22C10.4245 10.2549 10.3914 10.2978 10.3681 10.346C10.3448 10.3943 10.3316 10.4468 10.3296 10.5004C10.3275 10.5539 10.3365 10.6073 10.3561 10.6572C10.3756 10.7071 10.4053 10.7525 10.4432 10.7904C10.4811 10.8283 10.5264 10.8579 10.5763 10.8775C10.6262 10.897 10.6796 10.9061 10.7332 10.904C10.7867 10.9019 10.8393 10.8888 10.8875 10.8655C10.9358 10.8421 10.9787 10.8091 11.0136 10.7683L13.2224 8.55556L11.0136 6.35834Z"
        className="group-hover:fill-white fill-vorpblue"
      />
    </g>
    <defs>
      <clipPath id="clip0_1950_37605">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CustomizeLayoutIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
  pathClassName = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.15868 2C4.80335 2 5.32535 2.52267 5.32535 3.16667V12.8333C5.32535 12.9865 5.29517 13.1383 5.23654 13.2798C5.17791 13.4213 5.09197 13.55 4.98364 13.6583C4.8753 13.7666 4.74669 13.8526 4.60515 13.9112C4.4636 13.9698 4.31189 14 4.15868 14H2.49201C2.1826 14 1.88585 13.8771 1.66706 13.6583C1.44826 13.4395 1.32535 13.1428 1.32535 12.8333V3.16667C1.32554 2.87388 1.43581 2.59187 1.63427 2.37662C1.83273 2.16136 2.10488 2.02859 2.39668 2.00467L2.49201 2H4.15868ZM4.15868 3H2.49201L2.45401 3.00467C2.41734 3.01325 2.38466 3.03401 2.3613 3.06355C2.33793 3.09309 2.32526 3.12967 2.32535 3.16733V12.834C2.32535 12.926 2.40001 13.0007 2.49201 13.0007H4.15868C4.20288 13.0007 4.24528 12.9831 4.27653 12.9518C4.30779 12.9206 4.32535 12.8782 4.32535 12.834V3.16667C4.32535 3.12246 4.30779 3.08007 4.27653 3.04882C4.24528 3.01756 4.20288 3 4.15868 3ZM13.5093 2C14.154 2 14.676 2.52267 14.676 3.16667V7.51067C14.3608 7.37557 14.0183 7.31621 13.676 7.33733V3.16733C13.676 3.12313 13.6585 3.08074 13.6272 3.04948C13.5959 3.01823 13.5536 3.00067 13.5093 3.00067H11.8427C11.7985 3.00067 11.7561 3.01823 11.7248 3.04948C11.6936 3.08074 11.676 3.12313 11.676 3.16733V8.56067L10.676 9.56067V3.16733C10.676 2.52267 11.1987 2.00067 11.8427 2.00067H13.5093V2ZM13.676 12.7567L14.676 11.7567V12.834C14.676 13.1434 14.5531 13.4402 14.3343 13.659C14.1155 13.8778 13.8188 14.0007 13.5093 14.0007H12.4333L13.4333 13.0007H13.51C13.5542 13.0007 13.5966 12.9831 13.6279 12.9518C13.6591 12.9206 13.6767 12.8782 13.6767 12.834V12.7567H13.676ZM9.99201 3.16667V10.2453L8.99201 11.2453V3.16667C8.99201 3.12246 8.97446 3.08007 8.9432 3.04882C8.91194 3.01756 8.86955 3 8.82535 3H7.15868C7.11448 3 7.07209 3.01756 7.04083 3.04882C7.00957 3.08007 6.99201 3.12246 6.99201 3.16667V12.8333C6.99201 12.9253 7.06668 13 7.15868 13H7.69468C7.6901 13.0171 7.68565 13.0342 7.68135 13.0513L7.44402 14H7.15868C6.84926 14 6.55252 13.8771 6.33372 13.6583C6.11493 13.4395 5.99201 13.1428 5.99201 12.8333V3.16667C5.99201 2.52267 6.51468 2 7.15868 2H8.82535C9.47001 2 9.99201 2.52267 9.99201 3.16667ZM12.734 8.44667L8.80001 12.3813C8.57047 12.6106 8.40755 12.898 8.32868 13.2127L8.02401 14.4333C7.89068 14.964 8.37201 15.4447 8.90268 15.312L10.1227 15.0073C10.4376 14.9286 10.7252 14.7657 10.9547 14.536L14.8893 10.6013C15.1641 10.3134 15.3153 9.92938 15.3106 9.53141C15.3059 9.13345 15.1458 8.75311 14.8643 8.47168C14.5829 8.19026 14.2026 8.0301 13.8046 8.02542C13.4066 8.02075 13.0226 8.17193 12.7347 8.44667H12.734Z"
      className={twMerge(
        "fill-[#FFF0D2] group-hover:fill-vorphongkongborder transition-all duration-300",
        pathClassName
      )}
    />
  </svg>
);

export const SelectedIcon: FC<IIcon> = ({
  width = 12,
  height = 9,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.75 4.75L4.25 8.25L11.25 0.75"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SaveIcon: FC<IIcon> = ({
  width = 20,
  height = 20,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2308_1174)">
      <path
        d="M2.5 1.25C2.16848 1.25 1.85054 1.3817 1.61612 1.61612C1.3817 1.85054 1.25 2.16848 1.25 2.5V17.5C1.25 17.8315 1.3817 18.1495 1.61612 18.3839C1.85054 18.6183 2.16848 18.75 2.5 18.75H17.5C17.8315 18.75 18.1495 18.6183 18.3839 18.3839C18.6183 18.1495 18.75 17.8315 18.75 17.5V2.5C18.75 2.16848 18.6183 1.85054 18.3839 1.61612C18.1495 1.3817 17.8315 1.25 17.5 1.25H11.875C11.5435 1.25 11.2255 1.3817 10.9911 1.61612C10.7567 1.85054 10.625 2.16848 10.625 2.5V11.6163L13.9325 8.3075C14.0499 8.19014 14.209 8.12421 14.375 8.12421C14.541 8.12421 14.7001 8.19014 14.8175 8.3075C14.9349 8.42486 15.0008 8.58403 15.0008 8.75C15.0008 8.91597 14.9349 9.07514 14.8175 9.1925L10.4425 13.5675C10.3844 13.6257 10.3155 13.6719 10.2395 13.7034C10.1636 13.7349 10.0822 13.7511 10 13.7511C9.91779 13.7511 9.83639 13.7349 9.76046 13.7034C9.68453 13.6719 9.61556 13.6257 9.5575 13.5675L5.1825 9.1925C5.12439 9.13439 5.07829 9.0654 5.04685 8.98948C5.0154 8.91356 4.99921 8.83218 4.99921 8.75C4.99921 8.66782 5.0154 8.58644 5.04685 8.51052C5.07829 8.4346 5.12439 8.36561 5.1825 8.3075C5.24061 8.24939 5.3096 8.20329 5.38552 8.17185C5.46144 8.1404 5.54282 8.12421 5.625 8.12421C5.70718 8.12421 5.78856 8.1404 5.86448 8.17185C5.9404 8.20329 6.00939 8.24939 6.0675 8.3075L9.375 11.6163V2.5C9.375 1.83696 9.63839 1.20107 10.1072 0.732233C10.5761 0.263392 11.212 0 11.875 0L17.5 0C18.163 0 18.7989 0.263392 19.2678 0.732233C19.7366 1.20107 20 1.83696 20 2.5V17.5C20 18.163 19.7366 18.7989 19.2678 19.2678C18.7989 19.7366 18.163 20 17.5 20H2.5C1.83696 20 1.20107 19.7366 0.732233 19.2678C0.263392 18.7989 0 18.163 0 17.5V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0L5.625 0C5.79076 0 5.94973 0.065848 6.06694 0.183058C6.18415 0.300269 6.25 0.45924 6.25 0.625C6.25 0.79076 6.18415 0.949732 6.06694 1.06694C5.94973 1.18415 5.79076 1.25 5.625 1.25H2.5Z"
        className="fill-white group-hover:fill-vorpblue transition-all duration-300"
      />
    </g>
    <defs>
      <clipPath id="clip0_2308_1174">
        <rect
          width="20"
          height="20"
          className="fill-white group-hover:fill-vorpblue transition-all duration-300"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PolygonIcon: FC<IIcon> = ({
  width = 13,
  height = 13,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 13 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.02383 1.61482C5.81679 0.747376 7.18321 0.747377 7.97617 1.61482L11.6654 5.65058C12.8387 6.93404 11.9281 9 10.1892 9H2.81076C1.07186 9 0.161335 6.93404 1.33459 5.65058L5.02383 1.61482Z"
      fill="#4A4B68"
    />
  </svg>
);

export const AddIcon: FC<IIcon> = ({
  width = 12,
  height = 12,
  className = "",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.16666 11.8327V6.83268H0.166656V5.16602H5.16666V0.166016H6.83332V5.16602H11.8333V6.83268H6.83332V11.8327H5.16666Z"
      fill={color}
    />
  </svg>
);

export const TickIcon: FC<IIcon> = ({
  width = 17,
  height = 17,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.875 4.95773L6.37496 13.4577L2.47913 9.5619L3.47788 8.56315L6.37496 11.4532L13.8762 3.95898L14.875 4.95773Z"
      fill="#50CD89"
    />
  </svg>
);

export const TableSaveIcon: FC<IIcon> = ({
  width = 19,
  height = 18,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.8 16.2C1.305 16.2 0.8811 16.0239 0.5283 15.6717C0.1761 15.3189 0 14.895 0 14.4V1.8C0 1.305 0.1761 0.8811 0.5283 0.5283C0.8811 0.1761 1.305 0 1.8 0H12.6L16.2 3.6V8.46L8.46 16.2H1.8ZM2.7 6.3H10.8V2.7H2.7V6.3ZM8.1 13.5C8.85 13.5 9.4875 13.2375 10.0125 12.7125C10.5375 12.1875 10.8 11.55 10.8 10.8C10.8 10.05 10.5375 9.4125 10.0125 8.8875C9.4875 8.3625 8.85 8.1 8.1 8.1C7.35 8.1 6.7125 8.3625 6.1875 8.8875C5.6625 9.4125 5.4 10.05 5.4 10.8C5.4 11.55 5.6625 12.1875 6.1875 12.7125C6.7125 13.2375 7.35 13.5 8.1 13.5ZM10.8 18V16.4025L15.3 11.925L16.875 13.5225L12.3975 18H10.8ZM17.46 12.915L15.8625 11.34L16.6275 10.575C16.7175 10.485 16.8261 10.44 16.9533 10.44C17.0811 10.44 17.19 10.485 17.28 10.575L18.225 11.52C18.315 11.61 18.36 11.715 18.36 11.835C18.36 11.955 18.315 12.06 18.225 12.15L17.46 12.915Z"
      fill="white"
    />
  </svg>
);

export const DownloadAllIcon: FC<IIcon> = ({
  width = 10,
  height = 12,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.08366 11.8334H0.916992V10.6667H9.08366V11.8334ZM5.00033 9.50008L1.50033 6.00008L2.32283 5.17758L4.41699 7.26591V0.166748H5.58366V7.26591L7.67783 5.17758L8.50033 6.00008L5.00033 9.50008Z"
      className="fill-[#3699FF] group-hover:fill-white"
    />
  </svg>
);

export const PinIcon: FC<IIcon> = ({
  width = 14,
  height = 17,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3566 4.91336L8.38558 8.32723C7.94407 9.09194 7.78673 9.94788 7.88575 10.7698L3.7891 8.40456C4.57191 8.0736 5.22085 7.50149 5.65447 6.75043L7.62548 3.33655L10.3566 4.91336ZM13.1933 4.73041L6.36555 0.788401C5.99002 0.571591 5.50539 0.70145 5.28857 1.07698C5.07176 1.4525 5.20162 1.93714 5.57715 2.15395L6.25993 2.54815L4.28892 5.96203C3.63455 7.09544 2.1914 7.48213 1.05799 6.82776L0.269592 8.19331L4.34576 10.5467L1.58636 15.3261L1.87493 16.4031L2.95191 16.1145L5.71131 11.3351L9.82845 13.7121L10.6169 12.3466C9.48344 11.6922 9.09675 10.249 9.75113 9.11564L11.7221 5.70176L12.4049 6.09596C12.7804 6.31277 13.2651 6.18291 13.4819 5.80738C13.6987 5.43186 13.5688 4.94722 13.1933 4.73041Z"
      fill="white"
    />
  </svg>
);

export const SortAscendingIcon: FC<IIcon> = ({
  width = 17,
  height = 14,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7986 10.2984L13.2565 13.7983C13.1211 13.9277 12.9401 14 12.7517 14C12.5634 14 12.3824 13.9277 12.247 13.7983L8.70482 10.2984C8.60871 10.1972 8.54357 10.0712 8.51693 9.93493C8.49029 9.79867 8.50324 9.65774 8.55427 9.52845C8.60847 9.40105 8.69962 9.29235 8.81623 9.21606C8.93285 9.13976 9.06971 9.09928 9.20957 9.09971H12.0433V4.89984C12.0433 4.7142 12.1179 4.53616 12.2508 4.40489C12.3836 4.27361 12.5638 4.19987 12.7517 4.19987C12.9396 4.19987 13.1198 4.27361 13.2526 4.40489C13.3855 4.53616 13.4601 4.7142 13.4601 4.89984V9.09971H16.2939C16.4335 9.10041 16.5698 9.14135 16.6862 9.21751C16.8026 9.29366 16.894 9.40173 16.9492 9.52845C17.0002 9.65774 17.0131 9.79867 16.9865 9.93493C16.9599 10.0712 16.8947 10.1972 16.7986 10.2984ZM7.08428 5.59982H0.708429C0.520542 5.59982 0.34035 5.67357 0.207494 5.80484C0.0746379 5.93611 0 6.11415 0 6.2998C0 6.48545 0.0746379 6.66349 0.207494 6.79476C0.34035 6.92603 0.520542 6.99978 0.708429 6.99978H7.08428C7.27217 6.99978 7.45236 6.92603 7.58522 6.79476C7.71808 6.66349 7.79271 6.48545 7.79271 6.2998C7.79271 6.11415 7.71808 5.93611 7.58522 5.80484C7.45236 5.67357 7.27217 5.59982 7.08428 5.59982ZM0.708429 1.39996H12.7517C12.9396 1.39996 13.1198 1.32621 13.2526 1.19494C13.3855 1.06367 13.4601 0.885623 13.4601 0.699978C13.4601 0.514332 13.3855 0.33629 13.2526 0.205019C13.1198 0.0737476 12.9396 0 12.7517 0H0.708429C0.520542 0 0.34035 0.0737476 0.207494 0.205019C0.0746379 0.33629 0 0.514332 0 0.699978C0 0.885623 0.0746379 1.06367 0.207494 1.19494C0.34035 1.32621 0.520542 1.39996 0.708429 1.39996ZM5.66743 11.1996H0.708429C0.520542 11.1996 0.34035 11.2734 0.207494 11.4047C0.0746379 11.5359 0 11.714 0 11.8996C0 12.0853 0.0746379 12.2633 0.207494 12.3946C0.34035 12.5259 0.520542 12.5996 0.708429 12.5996H5.66743C5.85531 12.5996 6.03551 12.5259 6.16836 12.3946C6.30122 12.2633 6.37586 12.0853 6.37586 11.8996C6.37586 11.714 6.30122 11.5359 6.16836 11.4047C6.03551 11.2734 5.85531 11.1996 5.66743 11.1996Z"
      fill="#464E5F"
    />
  </svg>
);

export const SortDescendingIcon: FC<IIcon> = ({
  width = 17,
  height = 14,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7986 3.70158L13.2565 0.201688C13.1211 0.0723179 12.9401 -1.13126e-06 12.7517 -1.11479e-06C12.5634 -1.09832e-06 12.3824 0.0723179 12.247 0.201688L8.70481 3.70158C8.60871 3.80278 8.54357 3.92881 8.51693 4.06507C8.49029 4.20133 8.50323 4.34226 8.55427 4.47155C8.60847 4.59895 8.69962 4.70764 8.81623 4.78394C8.93285 4.86024 9.06971 4.90072 9.20957 4.90029L12.0433 4.90029L12.0433 9.10015C12.0433 9.2858 12.1179 9.46384 12.2508 9.59511C12.3836 9.72638 12.5638 9.80013 12.7517 9.80013C12.9396 9.80013 13.1198 9.72638 13.2526 9.59511C13.3855 9.46384 13.4601 9.2858 13.4601 9.10015L13.4601 4.90029L16.2939 4.90029C16.4335 4.89959 16.5698 4.85865 16.6862 4.78249C16.8026 4.70634 16.894 4.59827 16.9492 4.47155C17.0002 4.34226 17.0131 4.20133 16.9865 4.06507C16.9599 3.92881 16.8947 3.80278 16.7986 3.70158ZM7.08428 8.40018L0.708428 8.40018C0.520541 8.40018 0.34035 8.32643 0.207494 8.19516C0.0746374 8.06389 -5.34516e-07 7.88585 -5.50746e-07 7.7002C-5.66976e-07 7.51455 0.0746373 7.33651 0.207493 7.20524C0.34035 7.07397 0.520541 7.00022 0.708428 7.00022L7.08428 7.00022C7.27217 7.00022 7.45236 7.07397 7.58522 7.20524C7.71808 7.33651 7.79271 7.51455 7.79271 7.7002C7.79271 7.88584 7.71808 8.06389 7.58522 8.19516C7.45236 8.32643 7.27217 8.40018 7.08428 8.40018ZM0.708428 12.6L12.7517 12.6C12.9396 12.6 13.1198 12.6738 13.2526 12.8051C13.3855 12.9363 13.4601 13.1144 13.4601 13.3C13.4601 13.4857 13.3855 13.6637 13.2526 13.795C13.1198 13.9263 12.9396 14 12.7517 14L0.708429 14C0.520542 14 0.34035 13.9263 0.207494 13.795C0.0746379 13.6637 -4.49643e-08 13.4857 -6.1194e-08 13.3C-7.74237e-08 13.1144 0.0746378 12.9363 0.207494 12.8051C0.34035 12.6738 0.520541 12.6 0.708428 12.6ZM5.66743 2.80036L0.708428 2.80036C0.520541 2.80036 0.340349 2.72661 0.207493 2.59534C0.0746369 2.46407 -1.02407e-06 2.28602 -1.0403e-06 2.10038C-1.05653e-06 1.91473 0.0746369 1.73669 0.207493 1.60542C0.340349 1.47415 0.52054 1.4004 0.708427 1.4004L5.66743 1.4004C5.85531 1.4004 6.03551 1.47415 6.16836 1.60542C6.30122 1.73669 6.37586 1.91473 6.37586 2.10038C6.37586 2.28602 6.30122 2.46407 6.16836 2.59534C6.03551 2.72661 5.85531 2.80036 5.66743 2.80036Z"
      fill="#464E5F"
    />
  </svg>
);

export const DocumentIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.85 4.65L9.35 1.15C9.25 1.05 9.15 1 9 1H4C3.45 1 3 1.45 3 2V14C3 14.55 3.45 15 4 15H12C12.55 15 13 14.55 13 14V5C13 4.85 12.95 4.75 12.85 4.65ZM9 2.2L11.8 5H9V2.2ZM12 14H4V2H8V5C8 5.55 8.45 6 9 6H12V14Z"
      fill="white"
    />
    <path d="M5 11H11V12H5V11ZM5 8H11V9H5V8Z" fill="white" />
  </svg>
);

export const DraftIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0147 0H3.33769H3.33756C2.55672 0 1.82247 0.304188 1.27038 0.856313C0.718125 1.40841 0.414062 2.14263 0.414062 2.9235L0.414312 15.5C0.414312 15.7761 0.638187 16 0.914312 16H12.303C12.4356 16 12.5628 15.9474 12.6565 15.8535C12.7504 15.7598 12.803 15.6326 12.803 15.5L12.8028 10.9639L15.4273 8.33931C15.6226 8.14412 15.6226 7.8275 15.4273 7.63231L13.5369 5.74175C13.343 5.54791 13.0291 5.54631 12.8335 5.73809L12.8027 5.76837L12.8026 4.58347H15.4385C15.7146 4.58347 15.9385 4.35959 15.9385 4.08347V2.92397C15.9385 1.31184 14.6269 0.000125 13.0147 0ZM1.41428 15L1.41403 2.9235C1.41403 2.40972 1.61409 1.92669 1.97737 1.56344C2.34075 1.20019 2.82378 1 3.33769 1C4.39834 1.00013 5.26134 1.86312 5.26144 2.92375V4.0835C5.26144 4.35959 5.48531 4.5835 5.76144 4.5835H11.8026L11.8027 6.74775L7.92872 10.5422C7.83266 10.6363 7.77856 10.7651 7.77856 10.8993V12.7816C7.77856 13.057 8.00109 13.2803 8.27647 13.2816L10.2676 13.2899C10.2684 13.2899 10.269 13.2899 10.2697 13.2899C10.4023 13.2899 10.5294 13.2372 10.6232 13.1434L11.8028 11.9637L11.803 15H1.41428ZM10.0634 12.289L8.77856 12.2837V11.1095L11.602 8.34397L12.8052 9.54731L10.0634 12.289ZM13.1797 6.79875L14.3666 7.98584L13.5122 8.84019L12.3164 7.64431L13.1797 6.79875ZM6.26141 3.5835V2.92372C6.26128 2.18778 5.98797 1.51447 5.53756 0.999969H13.0147C14.0755 1.00009 14.9385 1.86322 14.9385 2.92397V3.5835H6.26141Z"
      fill="#3699FF"
    />
  </svg>
);

export const SolidDownloadIcon: FC<IIcon> = ({
  width = 10,
  height = 12,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.9375 4.3125H6.6875V0.9375H3.3125V4.3125H1.0625L5 8.8125L8.9375 4.3125ZM0.5 9.9375H9.5V11.0625H0.5V9.9375Z"
      fill="white"
    />
  </svg>
);

export const AssignIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0667 8.33464L15 9.27464L10.6467 13.668L8.33333 11.3346L9.26667 10.3946L10.6467 11.7813L14.0667 8.33464ZM6.66667 11.3346L8.66667 13.3346H2V12.0013C2 10.528 4.38667 9.33464 7.33333 9.33464L8.59333 9.40797L6.66667 11.3346ZM7.33333 2.66797C8.04058 2.66797 8.71885 2.94892 9.21895 3.44902C9.71905 3.94911 10 4.62739 10 5.33464C10 6.04188 9.71905 6.72016 9.21895 7.22025C8.71885 7.72035 8.04058 8.0013 7.33333 8.0013C6.62609 8.0013 5.94781 7.72035 5.44772 7.22025C4.94762 6.72016 4.66667 6.04188 4.66667 5.33464C4.66667 4.62739 4.94762 3.94911 5.44772 3.44902C5.94781 2.94892 6.62609 2.66797 7.33333 2.66797Z"
      fill="white"
    />
  </svg>
);

export const PaymentDoneIcon: FC<IIcon> = ({
  width = 12,
  height = 10,
  className = "",
  color = "#50CD89",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9999 1.66656L3.99992 9.66656L0.333252 5.9999L1.27325 5.0599L3.99992 7.7799L11.0599 0.726562L11.9999 1.66656Z"
      fill={color}
    />
  </svg>
);

export const ConfirmIcon: FC<IIcon> = ({
  width = 20,
  height = 20,
  className = "",
  pathClassName = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 17 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 8.33333V6.66667H7.16667V8.33333H0.5ZM0.5 5V3.33333H10.5V5H0.5ZM0.5 1.66667V0H10.5V1.66667H0.5ZM11.625 10.8333L8.66667 7.875L9.83333 6.70833L11.625 8.45833L15.1667 4.91667L16.3333 6.125L11.625 10.8333Z"
      className={`fill-white ${pathClassName} transition-all duration-300`}
    />
  </svg>
);

export const RemoveUserIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33333 7.96699C8.65556 7.61144 8.90289 7.20588 9.07533 6.75033C9.24733 6.29477 9.33333 5.82255 9.33333 5.33366C9.33333 4.84477 9.24733 4.37255 9.07533 3.91699C8.90289 3.46144 8.65556 3.05588 8.33333 2.70033C9 2.78921 9.55556 3.08366 10 3.58366C10.4444 4.08366 10.6667 4.66699 10.6667 5.33366C10.6667 6.00033 10.4444 6.58366 10 7.08366C9.55556 7.58366 9 7.8781 8.33333 7.96699ZM12 13.3337V11.3337C12 10.9337 11.9111 10.5532 11.7333 10.1923C11.5556 9.83099 11.3222 9.51144 11.0333 9.23366C11.6 9.43366 12.1251 9.69188 12.6087 10.0083C13.0918 10.3252 13.3333 10.767 13.3333 11.3337V13.3337H12ZM16 7.33366H12V6.00033H16V7.33366ZM5.33333 8.00033C4.6 8.00033 3.97222 7.73921 3.45 7.21699C2.92778 6.69477 2.66667 6.06699 2.66667 5.33366C2.66667 4.60033 2.92778 3.97255 3.45 3.45033C3.97222 2.9281 4.6 2.66699 5.33333 2.66699C6.06667 2.66699 6.69444 2.9281 7.21667 3.45033C7.73889 3.97255 8 4.60033 8 5.33366C8 6.06699 7.73889 6.69477 7.21667 7.21699C6.69444 7.73921 6.06667 8.00033 5.33333 8.00033ZM0 13.3337V11.467C0 11.0892 0.0973333 10.7419 0.292 10.425C0.486222 10.1085 0.744444 9.86699 1.06667 9.70033C1.75556 9.35588 2.45556 9.09744 3.16667 8.92499C3.87778 8.75299 4.6 8.66699 5.33333 8.66699C6.06667 8.66699 6.78889 8.75299 7.5 8.92499C8.21111 9.09744 8.91111 9.35588 9.6 9.70033C9.92222 9.86699 10.1804 10.1085 10.3747 10.425C10.5693 10.7419 10.6667 11.0892 10.6667 11.467V13.3337H0ZM5.33333 6.66699C5.7 6.66699 6.014 6.53632 6.27533 6.27499C6.53622 6.0141 6.66667 5.70033 6.66667 5.33366C6.66667 4.96699 6.53622 4.65321 6.27533 4.39233C6.014 4.13099 5.7 4.00033 5.33333 4.00033C4.96667 4.00033 4.65289 4.13099 4.392 4.39233C4.13067 4.65321 4 4.96699 4 5.33366C4 5.70033 4.13067 6.0141 4.392 6.27499C4.65289 6.53632 4.96667 6.66699 5.33333 6.66699ZM1.33333 12.0003H9.33333V11.467C9.33333 11.3448 9.30289 11.2337 9.242 11.1337C9.18067 11.0337 9.1 10.9559 9 10.9003C8.4 10.6003 7.79444 10.3752 7.18333 10.225C6.57222 10.0752 5.95556 10.0003 5.33333 10.0003C4.71111 10.0003 4.09444 10.0752 3.48333 10.225C2.87222 10.3752 2.26667 10.6003 1.66667 10.9003C1.56667 10.9559 1.48622 11.0337 1.42533 11.1337C1.364 11.2337 1.33333 11.3448 1.33333 11.467V12.0003Z"
      fill="white"
    />
  </svg>
);

export const EditIconFlat: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 8C13 7.86739 13.0527 7.74021 13.1464 7.64645C13.2402 7.55268 13.3674 7.5 13.5 7.5C13.6326 7.5 13.7598 7.55268 13.8536 7.64645C13.9473 7.74021 14 7.86739 14 8V13.5C14 13.6326 13.9473 13.7598 13.8536 13.8536C13.7598 13.9473 13.6326 14 13.5 14H2.5C2.36739 14 2.24021 13.9473 2.14645 13.8536C2.05268 13.7598 2 13.6326 2 13.5V2.5C2 2.36739 2.05268 2.24021 2.14645 2.14645C2.24021 2.05268 2.36739 2 2.5 2H8C8.13261 2 8.25979 2.05268 8.35355 2.14645C8.44732 2.24021 8.5 2.36739 8.5 2.5C8.5 2.63261 8.44732 2.75979 8.35355 2.85355C8.25979 2.94732 8.13261 3 8 3H3V13H13V8Z"
      fill="black"
    />
    <path
      d="M7.343 8.66001L8.168 8.54201L13.236 3.47501C13.2838 3.42888 13.3218 3.37371 13.3481 3.31271C13.3743 3.25171 13.388 3.1861 13.3886 3.11971C13.3892 3.05332 13.3766 2.98748 13.3514 2.92603C13.3263 2.86458 13.2891 2.80875 13.2422 2.76181C13.1953 2.71486 13.1394 2.67774 13.078 2.65259C13.0165 2.62745 12.9507 2.6148 12.8843 2.61538C12.8179 2.61596 12.7523 2.62975 12.6913 2.65596C12.6303 2.68216 12.5751 2.72025 12.529 2.76801L7.46 7.83501L7.342 8.66001H7.343ZM13.943 2.06001C14.0824 2.19931 14.193 2.36471 14.2684 2.54676C14.3438 2.72881 14.3827 2.92394 14.3827 3.12101C14.3827 3.31807 14.3438 3.5132 14.2684 3.69525C14.193 3.8773 14.0824 4.04271 13.943 4.18201L8.758 9.36701C8.68154 9.44375 8.58223 9.49358 8.475 9.50901L6.825 9.74501C6.7481 9.75605 6.66969 9.74902 6.59598 9.72448C6.52228 9.69994 6.4553 9.65857 6.40037 9.60364C6.34544 9.54871 6.30406 9.48173 6.27952 9.40802C6.25498 9.33431 6.24796 9.2559 6.259 9.17901L6.495 7.52901C6.51015 7.4219 6.55963 7.3226 6.636 7.24601L11.822 2.06101C12.1033 1.7798 12.4848 1.62183 12.8825 1.62183C13.2802 1.62183 13.6617 1.7798 13.943 2.06101V2.06001Z"
      fill="black"
    />
  </svg>
);
export const ClosIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.6667 4.27301L11.7267 3.33301L8.00004 7.05967L4.27337 3.33301L3.33337 4.27301L7.06004 7.99967L3.33337 11.7263L4.27337 12.6663L8.00004 8.93967L11.7267 12.6663L12.6667 11.7263L8.94004 7.99967L12.6667 4.27301Z"
      fill="#464E5F"
    />
  </svg>
);
export const ShareIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clipPath="url(#clip0_3659_5572)">
      <path
        d="M16.8539 1.14615C16.9232 1.21548 16.9705 1.30362 16.99 1.39963C17.0096 1.49563 17.0005 1.59526 16.9639 1.68615L11.1449 16.2331C11.0937 16.3613 11.008 16.4727 10.8975 16.5553C10.7869 16.6379 10.6557 16.6884 10.5183 16.7012C10.3809 16.714 10.2427 16.6887 10.1187 16.628C9.9948 16.5673 9.89003 16.4736 9.81593 16.3572L6.63793 11.3622L1.64293 8.18415C1.52625 8.11013 1.43228 8.00532 1.3714 7.88128C1.31052 7.75723 1.28509 7.61878 1.29792 7.4812C1.31074 7.34362 1.36133 7.21226 1.44409 7.10161C1.52686 6.99096 1.63858 6.90532 1.76693 6.85415L16.3139 1.03715C16.4048 1.00056 16.5045 0.991482 16.6005 1.01104C16.6965 1.03059 16.7846 1.07792 16.8539 1.14715V1.14615ZM7.63593 11.0701L10.3969 15.4081L15.1299 3.57615L7.63593 11.0701ZM14.4229 2.86915L2.59093 7.60215L6.92993 10.3622L14.4239 2.86915H14.4229Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3659_5572">
        <rect width="16" height="16" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

export const CheckIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.75 8.75L6.25 12.25L13.25 4.75"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CompleteIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="material-symbols:order-approve-outline-sharp">
      <path
        id="Vector"
        d="M12.9562 15.1875L15.5625 12.6L14.775 11.8125L12.9562 13.5938L12.225 12.8625L11.4375 13.6688L12.9562 15.1875ZM4.5 6.75H13.5V5.25H4.5V6.75ZM13.5 17.25C12.4625 17.25 11.578 16.8843 10.8465 16.1528C10.115 15.4213 9.7495 14.537 9.75 13.5C9.75 12.4625 10.1158 11.578 10.8472 10.8465C11.5788 10.115 12.463 9.7495 13.5 9.75C14.5375 9.75 15.422 10.1158 16.1535 10.8472C16.885 11.5788 17.2505 12.463 17.25 13.5C17.25 14.5375 16.8843 15.422 16.1528 16.1535C15.4213 16.885 14.537 17.2505 13.5 17.25ZM2.25 16.5V2.25H15.75V8.75625C15.5125 8.64375 15.2688 8.55 15.0187 8.475C14.7687 8.4 14.5125 8.34375 14.25 8.30625V3.75H3.75V14.2875H8.30625C8.36875 14.675 8.46575 15.0437 8.59725 15.3937C8.72875 15.7437 8.9005 16.075 9.1125 16.3875L9 16.5L7.875 15.375L6.75 16.5L5.625 15.375L4.5 16.5L3.375 15.375L2.25 16.5ZM4.5 12.75H8.30625C8.34375 12.4875 8.4 12.2313 8.475 11.9813C8.55 11.7312 8.64375 11.4875 8.75625 11.25H4.5V12.75ZM4.5 9.75H9.825C10.3 9.2875 10.8532 8.92175 11.4847 8.65275C12.1163 8.38375 12.788 8.2495 13.5 8.25H4.5V9.75Z"
        fill="white"
      />
    </g>
  </svg>
);

export const CloseSmallIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.22753 6.22664C6.52045 5.93377 6.99533 5.93382 7.28819 6.22674L11.9999 10.9394L16.7135 6.22664C17.0065 5.93377 17.4813 5.93382 17.7742 6.22674C18.0671 6.51966 18.067 6.99453 17.7741 7.2874L13.061 11.9996L17.7741 16.7127C18.067 17.0056 18.067 17.4805 17.7741 17.7733C17.4812 18.0662 17.0064 18.0662 16.7135 17.7733L12.0008 13.0607L7.28814 17.7733C6.99525 18.0662 6.52038 18.0662 6.22748 17.7733C5.93459 17.4805 5.93459 17.0056 6.22748 16.7127L10.9397 12.0005L6.22743 7.2873C5.93457 6.99438 5.93461 6.5195 6.22753 6.22664Z"
      fill="white"
    />
  </svg>
);
export const DeleteIcon: FC<IIcon> = ({
  width = 16,
  height = 16,
  className = "",
  color = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 17"
    fill={color}
  >
    <path
      d="M2.5 1.5C1.94772 1.5 1.5 1.94772 1.5 2.5V3.5C1.5 4.05228 1.94772 4.5 2.5 4.5H3V13.5C3 14.6046 3.89543 15.5 5 15.5H11C12.1046 15.5 13 14.6046 13 13.5V4.5H13.5C14.0523 4.5 14.5 4.05228 14.5 3.5V2.5C14.5 1.94772 14.0523 1.5 13.5 1.5H10C10 0.947715 9.55229 0.5 9 0.5H7C6.44772 0.5 6 0.947715 6 1.5H2.5ZM5.5 5.5C5.77614 5.5 6 5.72386 6 6V13C6 13.2761 5.77614 13.5 5.5 13.5C5.22386 13.5 5 13.2761 5 13L5 6C5 5.72386 5.22386 5.5 5.5 5.5ZM8 5.5C8.27614 5.5 8.5 5.72386 8.5 6V13C8.5 13.2761 8.27614 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13V6C7.5 5.72386 7.72386 5.5 8 5.5ZM11 6V13C11 13.2761 10.7761 13.5 10.5 13.5C10.2239 13.5 10 13.2761 10 13V6C10 5.72386 10.2239 5.5 10.5 5.5C10.7761 5.5 11 5.72386 11 6Z"
      fill={color}
    />
  </svg>
);
export const MediaUpload: FC<IIcon> = ({
  width = 24,
  height = 24,
  className = "",
  color = "#3699FF",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6.96563 7.28469C6.82479 7.14249 6.74578 6.95045 6.74578 6.75031C6.74578 6.55018 6.82479 6.35813 6.96563 6.21594L11.4656 1.71594C11.6078 1.5751 11.7999 1.49609 12 1.49609C12.2001 1.49609 12.3922 1.5751 12.5344 1.71594L17.0344 6.21594C17.1752 6.35813 17.2542 6.55018 17.2542 6.75031C17.2542 6.95045 17.1752 7.14249 17.0344 7.28469C16.891 7.4233 16.6994 7.50079 16.5 7.50079C16.3006 7.50079 16.109 7.4233 15.9656 7.28469L12.75 4.05969V12.0003C12.75 12.1992 12.671 12.39 12.5303 12.5306C12.3897 12.6713 12.1989 12.7503 12 12.7503C11.8011 12.7503 11.6103 12.6713 11.4697 12.5306C11.329 12.39 11.25 12.1992 11.25 12.0003V4.05969L8.03437 7.28469C7.89218 7.42552 7.70014 7.50453 7.5 7.50453C7.29986 7.50453 7.10782 7.42552 6.96563 7.28469ZM22.5 12.7503V18.7503C22.5 19.1481 22.342 19.5297 22.0607 19.811C21.7794 20.0923 21.3978 20.2503 21 20.2503H3C2.60218 20.2503 2.22064 20.0923 1.93934 19.811C1.65804 19.5297 1.5 19.1481 1.5 18.7503V12.7503C1.5 12.3525 1.65804 11.971 1.93934 11.6897C2.22064 11.4083 2.60218 11.2503 3 11.2503H9.375C9.47446 11.2503 9.56984 11.2898 9.64017 11.3601C9.71049 11.4305 9.75 11.5259 9.75 11.6253V11.9534C9.75 13.2097 10.7812 14.2784 12.0469 14.2503C12.6355 14.238 13.1958 13.9956 13.6076 13.575C14.0195 13.1543 14.2501 12.589 14.25 12.0003V11.6253C14.25 11.5259 14.2895 11.4305 14.3598 11.3601C14.4302 11.2898 14.5255 11.2503 14.625 11.2503H21C21.3978 11.2503 21.7794 11.4083 22.0607 11.6897C22.342 11.971 22.5 12.3525 22.5 12.7503ZM18.75 15.7503C18.75 15.5278 18.684 15.3103 18.5604 15.1253C18.4368 14.9403 18.2611 14.7961 18.0555 14.7109C17.85 14.6258 17.6238 14.6035 17.4055 14.6469C17.1873 14.6903 16.9868 14.7975 16.8295 14.9548C16.6722 15.1122 16.565 15.3126 16.5216 15.5308C16.4782 15.7491 16.5005 15.9753 16.5856 16.1808C16.6708 16.3864 16.815 16.5621 17 16.6857C17.185 16.8093 17.4025 16.8753 17.625 16.8753C17.9234 16.8753 18.2095 16.7568 18.4205 16.5458C18.6315 16.3348 18.75 16.0487 18.75 15.7503Z"
      fill={color}
    />
  </svg>
);
export const MediaFolder: FC<IIcon> = ({
  width = 24,
  height = 24,
  className = "",
  color = "#3699FF",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      opacity="0.5"
      d="M20 6H11L9 4H4C2.9 4 2 4.9 2 6V10H22V8C22 6.9 21.1 6 20 6Z"
      fill={color}
    />
    <path
      d="M20 6H4C2.9 6 2 6.9 2 8V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6Z"
      fill={color}
    />
  </svg>
);
export const MediaClose: FC<IIcon> = ({
  width = 24,
  height = 24,
  className = "",
  color = "#fff",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16.2426 17.654L12 13.4114L7.75736 17.654L6.34315 16.2398L10.5858 11.9972L6.34315 7.75451L7.75736 6.3403L12 10.5829L16.2426 6.3403L17.6569 7.75451L13.4142 11.9972L17.6569 16.2398L16.2426 17.654Z"
      fill={color}
    />
  </svg>
);
export const LeftIcon: FC<IIcon> = ({
  width = 5,
  height = 8,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 5 8"
    fill="none"
  >
    <path
      d="M4.33525 6.92141C4.55492 7.13696 4.55492 7.48644 4.33525 7.70199C4.11558 7.91753 3.75942 7.91753 3.53975 7.70199L0.164753 4.3903C-0.0481976 4.18134 -0.0556483 3.84488 0.147851 3.62705L3.2416 0.31536C3.45152 0.0906523 3.80734 0.0754722 4.03635 0.281455C4.26535 0.487438 4.28082 0.836582 4.0709 1.06129L1.34108 3.98341L4.33525 6.92141Z"
      fill={color}
    />
  </svg>
);
export const RightIcon: FC<IIcon> = ({
  width = 5,
  height = 8,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 5 8"
    fill="none"
  >
    <path
      d="M0.664752 1.07859C0.445082 0.863037 0.445082 0.513563 0.664752 0.298014C0.884422 0.0824651 1.24058 0.0824651 1.46025 0.298014L4.83525 3.6097C5.0482 3.81866 5.05565 4.15512 4.85215 4.37295L1.7584 7.68464C1.54848 7.90935 1.19266 7.92453 0.963654 7.71854C0.73465 7.51256 0.719179 7.16342 0.9291 6.93871L3.65892 4.01659L0.664752 1.07859Z"
      fill={color}
    />
  </svg>
);
export const ProfileUploadIcon: FC<IIcon> = ({
  width = 200,
  height = 200,
  className = "",
  color = "#dcdcdc",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="upload-bg-transparent"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 200 200"
  >
    <g
      id="Group_48"
      data-name="Group 48"
      transform="translate(-1392.286 -1355.887)"
    >
      <path
        id="Path_156"
        data-name="Path 156"
        d="M1514.754,1434.352v2.039a2,2,0,0,1-.6,1.453,1.96,1.96,0,0,1-1.437.588h-40.857a1.962,1.962,0,0,1-1.439-.588,2.01,2.01,0,0,1-.6-1.453v-2.039a1.974,1.974,0,0,1,.6-1.437,1.917,1.917,0,0,1,1.439-.6h40.857a1.916,1.916,0,0,1,1.438.6,1.967,1.967,0,0,1,.6,1.438"
        transform="translate(0.001 0.001)"
        fill={color}
      />
      <path
        id="Path_157"
        data-name="Path 157"
        d="M1474.5,1432.311h2.041a2.007,2.007,0,0,1,1.453.6,1.954,1.954,0,0,1,.588,1.438v8.176a2.031,2.031,0,0,1-2.041,2.037H1474.5a1.917,1.917,0,0,1-1.437-.6,1.964,1.964,0,0,1-.6-1.436v-8.176a2.054,2.054,0,0,1,2.037-2.041"
        transform="translate(36.16 0.001)"
        fill={color}
      />
      <path
        id="Path_158"
        data-name="Path 158"
        d="M1471.857,1432.311h2.039a2.007,2.007,0,0,1,1.453.6,1.96,1.96,0,0,1,.586,1.438v8.176a2.027,2.027,0,0,1-2.039,2.037h-2.039a1.915,1.915,0,0,1-1.439-.6,1.973,1.973,0,0,1-.6-1.436v-8.176a2.057,2.057,0,0,1,2.041-2.041"
        transform="translate(0.001 0.001)"
        fill={color}
      />
      <path
        id="Path_159"
        data-name="Path 159"
        d="M1473.158,1446.932a2.733,2.733,0,0,1-1.645-4.918l10.934-8.2a2.778,2.778,0,0,1,3.229,0l10.92,7.705a2.728,2.728,0,0,1,.658,3.8,2.734,2.734,0,0,1-3.83.66l-9.332-6.59-9.289,7a2.821,2.821,0,0,1-1.645.543"
        transform="translate(8.298 13.411)"
        fill={color}
      />
      <path
        id="Path_160"
        data-name="Path 160"
        d="M1473.9,1460.977a2.723,2.723,0,0,1-2.73-2.73v-21.852a2.729,2.729,0,1,1,5.459,0v21.852a2.723,2.723,0,0,1-2.729,2.73"
        transform="translate(18.488 18.489)"
        fill={color}
      />
    </g>
  </svg>
);
export const XLSXIcon: FC<IIcon> = ({
  width = 200,
  height = 200,
  className = "",
  color = "#dcdcdc",
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    fill="#FFF"
    stroke-miterlimit="10"
    strokeWidth="2"
  >
    <path
      stroke="#979593"
      d="M67.1716,7H27c-1.1046,0-2,0.8954-2,2v78 c0,1.1046,0.8954,2,2,2h58c1.1046,0,2-0.8954,2-2V26.8284c0-0.5304-0.2107-1.0391-0.5858-1.4142L68.5858,7.5858 C68.2107,7.2107,67.702,7,67.1716,7z"
    />
    <path fill="none" stroke="#979593" d="M67,7v18c0,1.1046,0.8954,2,2,2h18" />
    <path
      fill="#C8C6C4"
      d="M51 61H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 60.5523 51.5523 61 51 61zM51 55H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 54.5523 51.5523 55 51 55zM51 49H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 48.5523 51.5523 49 51 49zM51 43H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 42.5523 51.5523 43 51 43zM51 67H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 66.5523 51.5523 67 51 67zM79 61H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 60.5523 79.5523 61 79 61zM79 67H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 66.5523 79.5523 67 79 67zM79 55H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 54.5523 79.5523 55 79 55zM79 49H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 48.5523 79.5523 49 79 49zM79 43H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 42.5523 79.5523 43 79 43zM65 61H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 60.5523 65.5523 61 65 61zM65 67H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 66.5523 65.5523 67 65 67zM65 55H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 54.5523 65.5523 55 65 55zM65 49H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 48.5523 65.5523 49 65 49zM65 43H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 42.5523 65.5523 43 65 43z"
    />
    <path
      fill="#107C41"
      d="M12,74h32c2.2091,0,4-1.7909,4-4V38c0-2.2091-1.7909-4-4-4H12c-2.2091,0-4,1.7909-4,4v32 C8,72.2091,9.7909,74,12,74z"
    />
    <path d="M16.9492,66l7.8848-12.0337L17.6123,42h5.8115l3.9424,7.6486c0.3623,0.7252,0.6113,1.2668,0.7471,1.6236 h0.0508c0.2617-0.58,0.5332-1.1436,0.8164-1.69L33.1943,42h5.335l-7.4082,11.9L38.7168,66H33.041l-4.5537-8.4017 c-0.1924-0.3116-0.374-0.6858-0.5439-1.1215H27.876c-0.0791,0.2684-0.2549,0.631-0.5264,1.0878L22.6592,66H16.9492z" />
  </svg>
);
export const DropdownICon: FC<IIcon> = ({
  width = 6,
  height = 6,
  className = "",
  color = "#B6B6B6",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    className={className}
    height={height}
    viewBox="0 0 10 6"
    fill="none"
  >
    <path
      d="M5 3.81846L8.88906 8.56553e-07L10 1.09077L5 6L-5.24496e-07 1.09077L1.11172 1.76636e-07L5.00079 3.81846L5 3.81846Z"
      fill={color}
    />
  </svg>
);
export const ErrorNotiICon: FC<IIcon> = ({
  width = 120,
  height = 120,
  className = "",
  color = "#B6B6B6",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    className={className}
    height={height}
    viewBox="0 0 120 120"
    fill="none"
  >
    <g filter="url(#filter0_d_6991_41111)">
      <circle cx="60" cy="56" r="40" fill="#EE436D" />
      <path
        d="M46.9333 72.3333L43.6667 69.0666L56.7333 56L43.6667 42.9333L46.9333 39.6666L60 52.7333L73.0667 39.6666L76.3333 42.9333L63.2667 56L76.3333 69.0666L73.0667 72.3333L60 59.2666L46.9333 72.3333Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_6991_41111"
        x="0"
        y="0"
        width="120"
        height="120"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6991_41111"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_6991_41111"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export const PlayerIcon: FC<IIcon> = ({
  width = 46,
  height = 46,
  className = "",
  color = "#3699FF6",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 46 46"
    fill="none"
  >
    <circle cx="23" cy="23" r="23" fill="#3699FF" />
    <path
      d="M19.7156 29.2778C19.3406 29.5215 18.9608 29.5354 18.576 29.3194C18.192 29.1041 18 28.7715 18 28.3215V16.6778C18 16.2278 18.192 15.8948 18.576 15.6788C18.9608 15.4635 19.3406 15.4778 19.7156 15.7215L28.8844 21.5434C29.2219 21.7684 29.3906 22.0871 29.3906 22.4996C29.3906 22.9121 29.2219 23.2309 28.8844 23.4559L19.7156 29.2778Z"
      fill="white"
    />
  </svg>
);
export const MicIcon: FC<IIcon> = ({
  width = 46,
  height = 46,
  className = "",
  color = "white",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    className={className}
    height={height}
    viewBox="0 0 46 46"
    fill="none"
  >
    <circle cx="23" cy="23" r="23" fill="#3699FF" />
    <path
      d="M23.5008 25.75C25.3683 25.75 26.8758 24.2425 26.8758 22.375V15.625C26.8758 13.7575 25.3683 12.25 23.5008 12.25C21.6333 12.25 20.1258 13.7575 20.1258 15.625V22.375C20.1258 24.2425 21.6333 25.75 23.5008 25.75ZM30.1496 22.375C29.5983 22.375 29.1371 22.78 29.0471 23.3313C28.5858 25.975 26.2796 28 23.5008 28C20.7221 28 18.4158 25.975 17.9546 23.3313C17.9149 23.0666 17.782 22.8249 17.5799 22.6496C17.3778 22.4742 17.1197 22.3769 16.8521 22.375C16.1658 22.375 15.6258 22.9825 15.7271 23.6575C16.2783 27.0325 18.9783 29.6763 22.3758 30.16V32.5C22.3758 33.1187 22.8821 33.625 23.5008 33.625C24.1196 33.625 24.6258 33.1187 24.6258 32.5V30.16C26.2813 29.9235 27.8183 29.1656 29.0139 27.9964C30.2095 26.8271 31.0013 25.3073 31.2746 23.6575C31.3871 22.9825 30.8358 22.375 30.1496 22.375Z"
      fill={color}
    />
  </svg>
);
export const MicStopIcon: FC<IIcon> = ({
  width = 46,
  height = 46,
  className = "",
  color = "white",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    className={className}
    viewBox="0 0 46 46"
    fill="none"
  >
    <circle cx="23" cy="23" r="23" fill="#3699FF" />
    <rect x="18" y="18" width="10" height="10" fill={color} />
  </svg>
);
export const RecMicIcon: FC<IIcon> = ({
  width = 27,
  height = 27,
  className = "",
  color = "#EE436D",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    className={className}
    viewBox="0 0 27 27"
    fill="none"
  >
    <path
      d="M13.5008 15.75C15.3683 15.75 16.8758 14.2425 16.8758 12.375V5.625C16.8758 3.7575 15.3683 2.25 13.5008 2.25C11.6333 2.25 10.1258 3.7575 10.1258 5.625V12.375C10.1258 14.2425 11.6333 15.75 13.5008 15.75ZM20.1496 12.375C19.5983 12.375 19.1371 12.78 19.0471 13.3313C18.5858 15.975 16.2796 18 13.5008 18C10.7221 18 8.41584 15.975 7.95459 13.3313C7.91492 13.0666 7.78204 12.8249 7.5799 12.6496C7.37777 12.4742 7.11966 12.3769 6.85209 12.375C6.16584 12.375 5.62584 12.9825 5.72709 13.6575C6.27834 17.0325 8.97834 19.6763 12.3758 20.16V22.5C12.3758 23.1187 12.8821 23.625 13.5008 23.625C14.1196 23.625 14.6258 23.1187 14.6258 22.5V20.16C16.2813 19.9235 17.8183 19.1656 19.0139 17.9964C20.2095 16.8271 21.0013 15.3073 21.2746 13.6575C21.3871 12.9825 20.8358 12.375 20.1496 12.375Z"
      fill={color}
    />
  </svg>
);
export const MemberIcon: FC<IIcon> = ({
  width = 16,
  height = 20,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    className={className}
    height={height}
    viewBox="0 0 16 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2C7.46957 2 6.96086 2.21071 6.58579 2.58579C6.21071 2.96086 6 3.46957 6 4H10C10 3.46957 9.78929 2.96086 9.41421 2.58579C9.03914 2.21071 8.53043 2 8 2ZM5.354 1C6.059 0.378 6.986 0 8 0C9.014 0 9.94 0.378 10.646 1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7893 1.96086 16 2.46957 16 3V18C16 18.5304 15.7893 19.0391 15.4142 19.4142C15.0391 19.7893 14.5304 20 14 20H2C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18V3C0 2.46957 0.210714 1.96086 0.585786 1.58579C0.960859 1.21071 1.46957 1 2 1H5.354ZM4.126 3H2V18H14V3H11.874C11.956 3.32 12 3.655 12 4V5C12 5.26522 11.8946 5.51957 11.7071 5.70711C11.5196 5.89464 11.2652 6 11 6H5C4.73478 6 4.48043 5.89464 4.29289 5.70711C4.10536 5.51957 4 5.26522 4 5V4C4 3.655 4.044 3.32 4.126 3ZM4 9C4 8.73478 4.10536 8.48043 4.29289 8.29289C4.48043 8.10536 4.73478 8 5 8H11C11.2652 8 11.5196 8.10536 11.7071 8.29289C11.8946 8.48043 12 8.73478 12 9C12 9.26522 11.8946 9.51957 11.7071 9.70711C11.5196 9.89464 11.2652 10 11 10H5C4.73478 10 4.48043 9.89464 4.29289 9.70711C4.10536 9.51957 4 9.26522 4 9ZM4 13C4 12.7348 4.10536 12.4804 4.29289 12.2929C4.48043 12.1054 4.73478 12 5 12H8C8.26522 12 8.51957 12.1054 8.70711 12.2929C8.89464 12.4804 9 12.7348 9 13C9 13.2652 8.89464 13.5196 8.70711 13.7071C8.51957 13.8946 8.26522 14 8 14H5C4.73478 14 4.48043 13.8946 4.29289 13.7071C4.10536 13.5196 4 13.2652 4 13Z"
      fill={color}
    />
  </svg>
);
export const CalendarBigIcon: FC<IIcon> = ({
  width = 80,
  height = 80,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    className={className}
    height={height}
    viewBox="0 0 81 80"
    fill="none"
  >
    <g opacity="0.5">
      <path
        d="M23.4209 36.6665H30.0876V43.3332H23.4209V36.6665ZM23.4209 49.9998H30.0876V56.6665H23.4209V49.9998ZM36.7542 36.6665H43.4209V43.3332H36.7542V36.6665ZM36.7542 49.9998H43.4209V56.6665H36.7542V49.9998ZM50.0876 36.6665H56.7542V43.3332H50.0876V36.6665ZM50.0876 49.9998H56.7542V56.6665H50.0876V49.9998Z"
        fill="#C4C4C4"
      />
      <path
        d="M16.7541 73.3332H63.4207C67.0974 73.3332 70.0874 70.3432 70.0874 66.6665V19.9998C70.0874 16.3232 67.0974 13.3332 63.4207 13.3332H56.7541V6.6665H50.0874V13.3332H30.0874V6.6665H23.4207V13.3332H16.7541C13.0774 13.3332 10.0874 16.3232 10.0874 19.9998V66.6665C10.0874 70.3432 13.0774 73.3332 16.7541 73.3332ZM63.4207 26.6665L63.4241 66.6665H16.7541V26.6665H63.4207Z"
        fill="#C4C4C4"
      />
    </g>
  </svg>
);

export const CalendarIcon2: FC<IIcon> = ({
  width = 80,
  height = 80,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6 10.1C15.6 9.94087 15.6632 9.78826 15.7757 9.67574C15.8883 9.56321 16.0409 9.5 16.2 9.5H17.4C17.5591 9.5 17.7117 9.56321 17.8243 9.67574C17.9368 9.78826 18 9.94087 18 10.1V11.3C18 11.4591 17.9368 11.6117 17.8243 11.7243C17.7117 11.8368 17.5591 11.9 17.4 11.9H16.2C16.0409 11.9 15.8883 11.8368 15.7757 11.7243C15.6632 11.6117 15.6 11.4591 15.6 11.3V10.1ZM12 10.1C12 9.94087 12.0632 9.78826 12.1757 9.67574C12.2883 9.56321 12.4409 9.5 12.6 9.5H13.8C13.9591 9.5 14.1117 9.56321 14.2243 9.67574C14.3368 9.78826 14.4 9.94087 14.4 10.1V11.3C14.4 11.4591 14.3368 11.6117 14.2243 11.7243C14.1117 11.8368 13.9591 11.9 13.8 11.9H12.6C12.4409 11.9 12.2883 11.8368 12.1757 11.7243C12.0632 11.6117 12 11.4591 12 11.3V10.1ZM6 13.7C6 13.5409 6.06321 13.3883 6.17574 13.2757C6.28826 13.1632 6.44087 13.1 6.6 13.1H7.8C7.95913 13.1 8.11174 13.1632 8.22426 13.2757C8.33679 13.3883 8.4 13.5409 8.4 13.7V14.9C8.4 15.0591 8.33679 15.2117 8.22426 15.3243C8.11174 15.4368 7.95913 15.5 7.8 15.5H6.6C6.44087 15.5 6.28826 15.4368 6.17574 15.3243C6.06321 15.2117 6 15.0591 6 14.9V13.7ZM9.6 13.7C9.6 13.5409 9.66321 13.3883 9.77574 13.2757C9.88826 13.1632 10.0409 13.1 10.2 13.1H11.4C11.5591 13.1 11.7117 13.1632 11.8243 13.2757C11.9368 13.3883 12 13.5409 12 13.7V14.9C12 15.0591 11.9368 15.2117 11.8243 15.3243C11.7117 15.4368 11.5591 15.5 11.4 15.5H10.2C10.0409 15.5 9.88826 15.4368 9.77574 15.3243C9.66321 15.2117 9.6 15.0591 9.6 14.9V13.7Z"
      fill="#858795"
    />
    <path
      d="M6.15625 2.5C6.31372 2.5 6.46474 2.56256 6.57609 2.67391C6.68744 2.78526 6.75 2.93628 6.75 3.09375V3.6875H16.25V3.09375C16.25 2.93628 16.3126 2.78526 16.4239 2.67391C16.5353 2.56256 16.6863 2.5 16.8438 2.5C17.0012 2.5 17.1522 2.56256 17.2636 2.67391C17.3749 2.78526 17.4375 2.93628 17.4375 3.09375V3.6875H18.625C19.2549 3.6875 19.859 3.93772 20.3044 4.38312C20.7498 4.82852 21 5.43261 21 6.0625V19.125C21 19.7549 20.7498 20.359 20.3044 20.8044C19.859 21.2498 19.2549 21.5 18.625 21.5H4.375C3.74511 21.5 3.14102 21.2498 2.69562 20.8044C2.25022 20.359 2 19.7549 2 19.125V6.0625C2 5.43261 2.25022 4.82852 2.69562 4.38312C3.14102 3.93772 3.74511 3.6875 4.375 3.6875H5.5625V3.09375C5.5625 2.93628 5.62506 2.78526 5.73641 2.67391C5.84776 2.56256 5.99878 2.5 6.15625 2.5V2.5ZM3.1875 7.25V19.125C3.1875 19.4399 3.31261 19.742 3.53531 19.9647C3.75801 20.1874 4.06006 20.3125 4.375 20.3125H18.625C18.9399 20.3125 19.242 20.1874 19.4647 19.9647C19.6874 19.742 19.8125 19.4399 19.8125 19.125V7.25H3.1875Z"
      fill="#858795"
    />
  </svg>
);

export const SettingIcon: FC<IIcon> = ({
  width = 80,
  height = 80,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14113_23733)">
      <path
        d="M7.56 13H6.44C6.0615 13 5.742 12.7165 5.697 12.34L5.5775 11.402C5.339 11.3245 5.109 11.229 4.8905 11.1175L4.1435 11.698C3.8405 11.9325 3.414 11.9055 3.151 11.635L2.3635 10.8475C2.095 10.587 2.068 10.1605 2.3025 9.858L2.883 9.1105C2.771 8.892 2.6755 8.662 2.5985 8.4235L1.6585 8.304C1.2835 8.258 1 7.9385 1 7.56V6.44C1 6.0615 1.2835 5.742 1.66 5.697L2.598 5.5775C2.6755 5.339 2.771 5.109 2.8825 4.8905L2.3025 4.1435C2.0675 3.8405 2.095 3.4135 2.366 3.1505L3.1535 2.363C3.414 2.0945 3.841 2.068 4.143 2.302L4.89 2.883C5.1085 2.7715 5.3385 2.676 5.5775 2.5985L5.697 1.6585C5.742 1.2835 6.0615 1 6.44 1H7.56C7.9385 1 8.258 1.2835 8.303 1.66L8.4225 2.598C8.6615 2.6755 8.8915 2.771 9.11 2.8825L9.857 2.302C10.1605 2.0675 10.5865 2.0945 10.8495 2.3655L11.637 3.153C11.9055 3.4135 11.9325 3.84 11.698 4.1425L11.1175 4.89C11.2295 5.1085 11.325 5.3385 11.402 5.577L12.342 5.6965C12.7165 5.742 13 6.0615 13 6.44V7.56C13 7.9385 12.7165 8.258 12.34 8.303L11.402 8.4225C11.3245 8.661 11.229 8.891 11.1175 9.1095L11.698 9.8565C11.933 10.1595 11.9055 10.586 11.6345 10.849L10.847 11.6365C10.5865 11.905 10.1595 11.9325 9.8575 11.6975L9.11 11.117C8.8915 11.229 8.6615 11.3245 8.423 11.4015L8.3035 12.3415C8.258 12.7165 7.9385 13 7.56 13ZM4.865 10.57C4.9065 10.57 4.949 10.5805 4.987 10.6015C5.2625 10.7555 5.561 10.8795 5.874 10.9695C5.97 10.997 6.0405 11.079 6.053 11.178L6.193 12.278C6.208 12.4035 6.3165 12.5 6.44 12.5H7.56C7.6835 12.5 7.792 12.4035 7.8065 12.2805L7.947 11.1785C7.9595 11.0795 8.03 10.9975 8.126 10.97C8.439 10.88 8.7375 10.756 9.013 10.602C9.1005 10.553 9.2095 10.5615 9.288 10.623L10.163 11.303C10.2635 11.381 10.4045 11.3745 10.4905 11.286L11.283 10.4935C11.3735 10.4055 11.3805 10.2645 11.3025 10.1635L10.6225 9.2885C10.561 9.2095 10.5525 9.101 10.6015 9.0135C10.7555 8.738 10.8795 8.4395 10.9695 8.1265C10.997 8.0305 11.079 7.96 11.178 7.9475L12.278 7.8075C12.4035 7.792 12.5 7.6835 12.5 7.56V6.44C12.5 6.3165 12.4035 6.208 12.2805 6.1935L11.1785 6.053C11.0795 6.0405 10.9975 5.97 10.97 5.874C10.88 5.561 10.756 5.2625 10.602 4.987C10.553 4.8995 10.561 4.791 10.623 4.712L11.303 3.837C11.3815 3.736 11.3745 3.595 11.2865 3.51L10.494 2.7175C10.4065 2.6265 10.265 2.6195 10.164 2.698L9.289 3.378C9.2095 3.4395 9.101 3.448 9.0135 3.399C8.739 3.245 8.4405 3.1215 8.1265 3.031C8.0305 3.0035 7.96 2.9215 7.9475 2.8225L7.8075 1.7225C7.792 1.5965 7.6835 1.5 7.56 1.5H6.44C6.3165 1.5 6.208 1.5965 6.1935 1.7195L6.053 2.8215C6.0405 2.9205 5.97 3.0025 5.874 3.0305C5.56 3.1205 5.2615 3.2445 4.987 3.398C4.8995 3.4475 4.791 3.4385 4.7115 3.3775L3.8365 2.6975C3.7355 2.619 3.595 2.626 3.5095 2.714L2.717 3.507C2.6265 3.595 2.6195 3.736 2.6975 3.837L3.3775 4.712C3.439 4.791 3.4475 4.8995 3.3985 4.987C3.244 5.2625 3.1205 5.561 3.0305 5.874C3.003 5.97 2.921 6.0405 2.822 6.053L1.722 6.193C1.5965 6.208 1.5 6.3165 1.5 6.44V7.56C1.5 7.6835 1.5965 7.792 1.7195 7.8065L2.8215 7.947C2.9205 7.9595 3.0025 8.03 3.03 8.126C3.12 8.439 3.244 8.7375 3.398 9.013C3.447 9.1005 3.439 9.209 3.377 9.288L2.697 10.163C2.6185 10.264 2.6255 10.405 2.7135 10.49L3.506 11.2825C3.5935 11.373 3.734 11.38 3.836 11.302L4.711 10.622C4.7565 10.588 4.8105 10.57 4.865 10.57Z"
        fill="#3699FF"
      />
      <path
        d="M7.00012 9.5C5.62162 9.5 4.50012 8.3785 4.50012 7C4.50012 5.6215 5.62162 4.5 7.00012 4.5C8.37862 4.5 9.50012 5.6215 9.50012 7C9.50012 8.3785 8.37862 9.5 7.00012 9.5ZM7.00012 5C5.89712 5 5.00012 5.897 5.00012 7C5.00012 8.103 5.89712 9 7.00012 9C8.10312 9 9.00012 8.103 9.00012 7C9.00012 5.897 8.10312 5 7.00012 5Z"
        fill="#3699FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_14113_23733">
        <rect width="12" height="12" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

export const UpOpenIcon: FC<IIcon> = ({
  width = 10,
  height = 5,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 5L5 0L0 5H10Z" fill="#C4C4C4" />
  </svg>
);

export const DownCloseIcon: FC<IIcon> = ({
  width = 10,
  height = 5,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0L5 5L10 0H0Z" fill="#C4C4C4" />
  </svg>
);
export const ReturnIcon: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M2.17084 12.6708L2.10013 12.6001L4.43348 10.2668C4.70034 9.99996 5.13301 9.99996 5.39987 10.2668C5.66672 10.5337 5.66672 10.9663 5.39987 11.2332L4.23306 12.4H10.1667C12.7048 12.4 14.7333 10.3714 14.7333 7.83332C14.7333 5.29522 12.7048 3.26665 10.1666 3.26665H2.58332C2.20593 3.26665 1.9 2.96072 1.9 2.58332C1.9 2.20593 2.20593 1.9 2.58332 1.9H10.1667C13.4596 1.9 16.1 4.54043 16.1 7.83332C16.1 11.1262 13.4596 13.7667 10.1666 13.7666H4.23303L5.39984 14.9335C5.66669 15.2003 5.66669 15.633 5.39984 15.8998C5.13299 16.1667 4.70031 16.1667 4.43346 15.8998L2.10021 13.5666L2.10013 13.5665L2.17084 12.6708ZM2.17084 12.6708L2.10013 12.6001L2.17084 12.6708ZM2.05614 12.8349L1.96561 12.7924C1.96613 12.7913 1.96677 12.7899 1.96751 12.7883C1.97068 12.7814 1.97561 12.7707 1.98075 12.7612C1.98533 12.7526 1.99133 12.7428 1.99482 12.7371C1.99573 12.7356 1.99647 12.7344 1.99697 12.7335L1.99697 12.7335C1.9976 12.7325 1.99841 12.7311 1.99936 12.7295C2.00313 12.7231 2.00919 12.7127 2.01512 12.7039L2.0529 12.8416C2.05398 12.8394 2.05507 12.8371 2.05614 12.8349ZM2.05614 12.8349L1.96571 12.7922C1.96523 12.7932 1.96457 12.7946 1.96379 12.7962C1.96075 12.8025 1.95588 12.8126 1.95207 12.8217L1.95197 12.822M2.05614 12.8349L1.95197 12.822M1.95197 12.822C1.9481 12.8314 1.94443 12.8419 1.94208 12.8486M1.95197 12.822L1.94208 12.8486M1.91318 12.95L1.91321 12.9498C1.91532 12.9393 1.91833 12.9278 1.92024 12.9205L1.91318 12.95ZM1.91318 12.95C1.911 12.9611 1.90935 12.9731 1.90826 12.9811C1.908 12.983 1.90777 12.9847 1.90757 12.9861L1.90755 12.9862M1.91318 12.95L1.90755 12.9862M1.90755 12.9862C1.90753 12.9864 1.90747 12.9868 1.90736 12.9874M1.90755 12.9862L1.90736 12.9874M2.05489 13.5165C2.06851 13.5331 2.083 13.5493 2.09843 13.5648L2.05489 13.5165ZM2.05489 13.5165C2.04896 13.5093 2.04122 13.4986 2.03798 13.4941M2.05489 13.5165L2.03798 13.4941M1.91318 13.2167L1.91316 13.2167C1.91099 13.2057 1.90934 13.1935 1.90826 13.1856C1.908 13.1837 1.90777 13.182 1.90758 13.1806C1.90753 13.1803 1.9074 13.1795 1.90722 13.1784L1.91318 13.2167ZM1.91318 13.2167C1.91529 13.2274 1.9183 13.2389 1.92022 13.2462M1.91318 13.2167L1.92022 13.2462M1.94073 13.3142L1.94072 13.3142C1.94031 13.313 1.93977 13.3116 1.93914 13.3098L1.94073 13.3142ZM1.94073 13.3142C1.9411 13.3152 1.9416 13.3166 1.9422 13.3184C1.94449 13.3249 1.94823 13.3356 1.95197 13.3447L1.95197 13.3447M1.94073 13.3142L1.95197 13.3447M1.95197 13.3447C1.95581 13.354 1.9609 13.3645 1.96389 13.3707M1.95197 13.3447L1.96389 13.3707M1.98082 13.4056L1.98072 13.4054C1.97574 13.3961 1.97085 13.3855 1.96771 13.3788L1.98082 13.4056ZM1.98082 13.4056C1.98536 13.4141 1.99126 13.4237 1.99477 13.4295C1.99569 13.431 1.99645 13.4322 1.99697 13.4331L1.99697 13.4331M1.98082 13.4056L1.99697 13.4331M1.99697 13.4331C1.99759 13.4341 1.99841 13.4355 1.99938 13.4372M1.99697 13.4331L1.99938 13.4372M2.03657 13.4922L2.03652 13.4921C2.03574 13.491 2.03472 13.4897 2.03351 13.4881C2.02876 13.4819 2.02124 13.472 2.01508 13.4627M2.03657 13.4922L2.01508 13.4627L2.09816 13.4073L2.01508 13.4627M2.03657 13.4922C2.03679 13.4924 2.03728 13.4931 2.03798 13.4941M2.03657 13.4922L2.03798 13.4941M2.01508 13.4627C2.00922 13.454 2.00313 13.4436 1.99938 13.4372M2.01508 13.4627L1.99938 13.4372M1.94208 12.8486C1.94152 12.8502 1.94103 12.8516 1.94064 12.8528M1.94208 12.8486L1.94064 12.8528M1.94064 12.8528L2.03484 12.8863L1.94064 12.8528ZM1.92232 12.9122C1.9239 12.9056 1.92658 12.8945 1.92944 12.8851L1.92232 12.9122ZM1.92232 12.9122C1.92194 12.9138 1.92162 12.9151 1.92138 12.9161L1.92232 12.9122ZM1.90736 12.9874C1.90667 12.9917 1.90426 13.0067 1.90335 13.0159L1.90736 12.9874ZM1.92022 13.2462C1.92068 13.248 1.92108 13.2495 1.92139 13.2507M1.92022 13.2462L1.92139 13.2507M1.92139 13.2507L2.01832 13.2262M1.92139 13.2507L2.01832 13.2262M2.01832 13.2262L1.92132 13.2505C1.92157 13.2515 1.9219 13.2529 1.9223 13.2545M2.01832 13.2262C2.01771 13.2238 2.01708 13.2213 2.01645 13.2189L1.9223 13.2545M2.01832 13.2262C2.01894 13.2286 2.01953 13.2311 2.02013 13.2335C2.02167 13.2399 2.02321 13.2463 2.02513 13.2526L2.01832 13.2262ZM1.9223 13.2545C1.92388 13.2611 1.92654 13.2721 1.92938 13.2815L1.9223 13.2545ZM1.96389 13.3707C1.96465 13.3723 1.96527 13.3735 1.96571 13.3745L1.96389 13.3707ZM2.05488 12.6502C2.04895 12.6574 2.04125 12.6681 2.03801 12.6726C2.03736 12.6735 2.03689 12.6741 2.03665 12.6744C2.03585 12.6755 2.03486 12.6768 2.03372 12.6783L2.05488 12.6502ZM1.90335 13.0159C1.89894 13.0607 1.89894 13.1059 1.90335 13.1506L1.90335 13.0159Z"
      fill="#FEFCFF"
      stroke="#FEFCFF"
      stroke-width="0.2"
    />
  </svg>
);
export const ApplyIcon: FC<IIcon> = ({
  width = 18,
  height = 18,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M7.32492 13.6924C7.35892 13.6976 7.3932 13.7 7.4265 13.7C7.59358 13.7 7.75603 13.6389 7.8831 13.5265L7.88315 13.5265L12.6239 9.32646L12.6978 9.26096L12.6332 9.18622L11.8526 8.283L11.7864 8.20641L7.33999 13.5936M7.32492 13.6924C7.32489 13.6924 7.32486 13.6924 7.32482 13.6924L7.33999 13.5936M7.32492 13.6924C7.32503 13.6924 7.32513 13.6924 7.32524 13.6925L7.33999 13.5936M7.32492 13.6924C7.12376 13.6623 6.94608 13.5444 6.8388 13.3705M7.33999 13.5936C7.16811 13.5679 7.01591 13.4671 6.9239 13.318M6.8388 13.3705L6.83881 13.3705L6.9239 13.318M6.8388 13.3705L6.9239 13.318M6.8388 13.3705L6.9239 13.318M11.7769 8.34839L11.8423 8.42405L11.8432 8.42324L11.7769 8.34839ZM11.7769 8.34839L11.7013 8.41378L11.7021 8.41471L11.7769 8.34839ZM7.63615 12.017L7.58284 11.9307L7.50687 11.998L6.50016 10.3671L6.5011 10.3665L6.44763 10.282L6.36253 10.3345L6.36312 10.3355L7.63615 12.017ZM7.63615 12.017L7.56019 12.0843L7.63615 12.017ZM4.75185 2.1H3.37037C2.00697 2.1 0.9 3.22261 0.9 4.6V13.6C0.9 14.9774 2.00697 16.1 3.37037 16.1H14.6296C15.993 16.1 17.1 14.9774 17.1 13.6V4.6C17.1 3.22261 15.993 2.1 14.6296 2.1H13.2481V1V0.9H13.1481H11.963H11.863V1V2.1H6.13704V1V0.9H6.03704H4.85185H4.75185V1V2.1ZM13.2481 4.6V3.5H14.6296C15.2269 3.5 15.7148 3.99238 15.7148 4.6V6H2.28519V4.6C2.28519 3.99238 2.77313 3.5 3.37037 3.5H4.75185V4.6V4.7H4.85185H6.03704H6.13704V4.6V3.5H11.863V4.6V4.7H11.963H13.1481H13.2481V4.6ZM14.6296 14.7H3.37037C2.77313 14.7 2.28519 14.2076 2.28519 13.6V7.4H15.7148V13.6C15.7148 14.2076 15.2269 14.7 14.6296 14.7Z"
      fill="#FEFCFF"
      stroke="#FEFCFF"
      stroke-width="0.2"
    />
  </svg>
);

export const QuestionIcon: FC<IIcon> = ({
  width = 10,
  height = 5,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="16" height="16" rx="8" fill="#C4C4C4" />
    <path
      d="M7.98212 4.22754C8.79812 4.22754 9.45012 4.45154 9.93812 4.89954C10.4341 5.34754 10.6821 5.95954 10.6821 6.73554C10.6821 7.54354 10.4261 8.15154 9.91412 8.55954C9.40212 8.96754 8.72212 9.17154 7.87412 9.17154L7.82612 10.1195H6.63812L6.57812 8.23554H6.97412C7.75012 8.23554 8.34212 8.13154 8.75012 7.92354C9.16612 7.71554 9.37412 7.31954 9.37412 6.73554C9.37412 6.31154 9.25012 5.97954 9.00212 5.73954C8.76212 5.49954 8.42612 5.37954 7.99412 5.37954C7.56212 5.37954 7.22212 5.49554 6.97412 5.72754C6.72612 5.95954 6.60212 6.28354 6.60212 6.69954H5.31812C5.31812 6.21954 5.42612 5.79154 5.64212 5.41554C5.85812 5.03954 6.16612 4.74754 6.56612 4.53954C6.97412 4.33154 7.44612 4.22754 7.98212 4.22754ZM7.21412 12.7715C6.96612 12.7715 6.75812 12.6875 6.59012 12.5195C6.42212 12.3515 6.33812 12.1435 6.33812 11.8955C6.33812 11.6475 6.42212 11.4395 6.59012 11.2715C6.75812 11.1035 6.96612 11.0195 7.21412 11.0195C7.45412 11.0195 7.65812 11.1035 7.82612 11.2715C7.99412 11.4395 8.07812 11.6475 8.07812 11.8955C8.07812 12.1435 7.99412 12.3515 7.82612 12.5195C7.65812 12.6875 7.45412 12.7715 7.21412 12.7715Z"
      fill="#FEFCFF"
    />
  </svg>
);

export const NextIcon: FC<IIcon> = ({
  width = 14,
  height = 14,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    width={width}
    height={width}
    className={className}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 0.875C1.51794 0.875 1.29538 0.967187 1.13128 1.13128C0.967187 1.29538 0.875 1.51794 0.875 1.75V12.25C0.875 12.4821 0.967187 12.7046 1.13128 12.8687C1.29538 13.0328 1.51794 13.125 1.75 13.125H12.25C12.4821 13.125 12.7046 13.0328 12.8687 12.8687C13.0328 12.7046 13.125 12.4821 13.125 12.25V1.75C13.125 1.51794 13.0328 1.29538 12.8687 1.13128C12.7046 0.967187 12.4821 0.875 12.25 0.875H8.3125C8.08044 0.875 7.85788 0.967187 7.69378 1.13128C7.52969 1.29538 7.4375 1.51794 7.4375 1.75V8.13138L9.75275 5.81525C9.8349 5.7331 9.94632 5.68695 10.0625 5.68695C10.1787 5.68695 10.2901 5.7331 10.3722 5.81525C10.4544 5.8974 10.5006 6.00882 10.5006 6.125C10.5006 6.24118 10.4544 6.3526 10.3722 6.43475L7.30975 9.49725C7.26911 9.53799 7.22083 9.57032 7.16768 9.59237C7.11453 9.61443 7.05755 9.62578 7 9.62578C6.94245 9.62578 6.88547 9.61443 6.83232 9.59237C6.77917 9.57032 6.73089 9.53799 6.69025 9.49725L3.62775 6.43475C3.58707 6.39407 3.55481 6.34578 3.53279 6.29264C3.51078 6.23949 3.49945 6.18253 3.49945 6.125C3.49945 6.06747 3.51078 6.01051 3.53279 5.95736C3.55481 5.90422 3.58707 5.85593 3.62775 5.81525C3.66843 5.77457 3.71672 5.74231 3.76986 5.72029C3.82301 5.69828 3.87997 5.68695 3.9375 5.68695C3.99503 5.68695 4.05199 5.69828 4.10514 5.72029C4.15828 5.74231 4.20657 5.77457 4.24725 5.81525L6.5625 8.13138V1.75C6.5625 1.28587 6.74687 0.840752 7.07506 0.512563C7.40325 0.184374 7.84837 0 8.3125 0L12.25 0C12.7141 0 13.1592 0.184374 13.4874 0.512563C13.8156 0.840752 14 1.28587 14 1.75V12.25C14 12.7141 13.8156 13.1592 13.4874 13.4874C13.1592 13.8156 12.7141 14 12.25 14H1.75C1.28587 14 0.840752 13.8156 0.512563 13.4874C0.184374 13.1592 0 12.7141 0 12.25V1.75C0 1.28587 0.184374 0.840752 0.512563 0.512563C0.840752 0.184374 1.28587 0 1.75 0L3.9375 0C4.05353 0 4.16481 0.0460936 4.24686 0.128141C4.32891 0.210188 4.375 0.321468 4.375 0.4375C4.375 0.553532 4.32891 0.664812 4.24686 0.746859C4.16481 0.828906 4.05353 0.875 3.9375 0.875H1.75Z"
      fill="#FEFCFF"
    />
  </svg>
);

export const DuplicateIcon: FC<IIcon> = ({
  width = 10,
  height = 5,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="32" height="32" rx="6" fill="#FFA800" />
    <path
      d="M23.2502 8.35H23.25L13.5 8.35L13.4998 8.35C13.2613 8.35027 13.0325 8.44516 12.8638 8.61385L12.8638 8.61385C12.6952 8.78254 12.6003 9.01126 12.6 9.24983V9.25L12.6 19L12.6 19.0002C12.6003 19.2388 12.6952 19.4674 12.8638 19.6361L12.8638 19.6361C13.0325 19.8048 13.2612 19.8998 13.4998 19.9H13.5H23.25H23.2502C23.4888 19.8998 23.7175 19.8048 23.8861 19.6361C24.0548 19.4675 24.1498 19.2388 24.15 19.0002V19V9.25V9.24985C24.1498 9.01124 24.0548 8.78253 23.8861 8.61385L23.8861 8.61385C23.7174 8.44516 23.4888 8.35027 23.2502 8.35ZM22.85 18.6H13.9V9.65H22.85V18.6Z"
      fill="white"
      stroke="white"
      strokeWidth="0.3"
    />
    <path
      d="M19.1 20.75V22.35H10.15V13.4H11.75H11.9V13.25V12.25V12.1H11.75L9.75 12.1L9.74983 12.1C9.51126 12.1003 9.28254 12.1952 9.11385 12.3638L9.11385 12.3638C8.94516 12.5325 8.85027 12.7613 8.85 12.9998V13L8.85 22.75L8.85 22.7502C8.85027 22.9888 8.94516 23.2174 9.11385 23.3861L9.11385 23.3861C9.28253 23.5548 9.51124 23.6498 9.74985 23.65H9.75H19.5H19.5002C19.7388 23.6498 19.9675 23.5548 20.1361 23.3861C20.3048 23.2175 20.3998 22.9888 20.4 22.7502V22.75V20.75V20.6H20.25H19.25H19.1V20.75Z"
      fill="white"
      stroke="white"
      strokeWidth="0.3"
    />
  </svg>
);

export const EmailIcon: FC<IIcon> = ({
  width = 10,
  height = 5,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    // width="18"
    // height="18"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_20511_14183)">
      <path
        d="M16.2149 3.1084H1.78513C0.800759 3.1084 0 3.90912 0 4.89353V13.1067C0 14.0911 0.800759 14.8918 1.78513 14.8918H16.2149C17.1992 14.8918 18 14.0911 18 13.1067V4.89353C18 3.90912 17.1993 3.1084 16.2149 3.1084ZM16.8099 4.89353V13.1067C16.8099 13.2006 16.7835 13.2863 16.7445 13.3653L12.5377 9.15815L16.8087 4.88711C16.8087 4.88948 16.8099 4.89119 16.8099 4.89353ZM1.19009 13.1067V4.89353C1.19009 4.89119 1.19129 4.88952 1.19129 4.88714L5.46233 9.15819L1.25519 13.3653C1.21653 13.2863 1.19009 13.2006 1.19009 13.1067ZM9.18367 10.8294C9.08548 10.9276 8.91456 10.9276 8.81637 10.8294L2.28574 4.29848H15.7146L9.18367 10.8294ZM6.30376 9.99965L7.97494 11.6709C8.24894 11.9448 8.61299 12.0956 9.00002 12.0956C9.38701 12.0956 9.7511 11.9448 10.0251 11.6709L11.6963 9.99965L15.3981 13.7018H2.60161L6.30376 9.99965Z"
        fill="#464E5F"
      />
    </g>
    <defs>
      <clipPath id="clip0_20511_14183">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UpArrowIcon: FC<IIcon> = ({
  width = 10,
  height = 5,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    className={className}
    width="10"
    height="13"
    viewBox="0 0 10 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 1L7.5 6.46784L2.56667 12"
      stroke="#858795"
      stroke-width="1.73697"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DownArrowIcon: FC<IIcon> = ({
  width = 10,
  height = 5,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    className={className}
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 3L7.03216 8L1.5 3.06667"
      stroke="#858795"
      stroke-width="1.73697"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DownLoadIcon: FC<IIcon> = ({
  width = 10,
  height = 5,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    className={className}
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4987 13.332L6.33203 9.16536L7.4987 7.95703L9.66536 10.1237V3.33203H11.332V10.1237L13.4987 7.95703L14.6654 9.16536L10.4987 13.332ZM5.4987 16.6654C5.04036 16.6654 4.64814 16.5023 4.32203 16.1762C3.99592 15.8501 3.83259 15.4576 3.83203 14.9987V12.4987H5.4987V14.9987H15.4987V12.4987H17.1654V14.9987C17.1654 15.457 17.0023 15.8495 16.6762 16.1762C16.3501 16.5029 15.9576 16.6659 15.4987 16.6654H5.4987Z"
      fill="#464E5F"
    />
  </svg>
);

export const StarIcon2: FC<IIcon> = ({
  width = 10,
  height = 5,
  className = "",
  color = "#464E5F",
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    // width="20"
    // height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8376 7.16736L12.5984 7.11554L12.4752 6.90404L10.3439 3.24541C10.3439 3.24539 10.3439 3.24536 10.3439 3.24534C10.3089 3.1853 10.2587 3.13549 10.1985 3.10086C10.1382 3.06622 10.0699 3.04799 10.0004 3.04799C9.93084 3.04799 9.86253 3.06622 9.80225 3.10086C9.74196 3.1355 9.69182 3.18534 9.65681 3.24541L7.52554 6.90404L7.40233 7.11554L7.16313 7.16736L3.02402 8.06412C2.95604 8.07884 2.89312 8.11115 2.84152 8.1578C2.78993 8.20445 2.75148 8.26382 2.73001 8.32997C2.70853 8.39613 2.70479 8.46676 2.71915 8.53482C2.73351 8.60288 2.76547 8.66598 2.81184 8.71782L2.81199 8.71799L5.63342 11.8749L5.79661 12.0575L5.77191 12.3012L5.34489 16.5142L5.34487 16.5144C5.33785 16.5836 5.3491 16.6534 5.3775 16.7169C5.40591 16.7804 5.45047 16.8353 5.50675 16.8762C5.56302 16.9171 5.62904 16.9425 5.69821 16.9499C5.76738 16.9573 5.83728 16.9464 5.90092 16.9183L5.90102 16.9183L9.77629 15.2102L10.0004 15.1114L10.2244 15.2102L14.0997 16.9183L14.0998 16.9183C14.1635 16.9464 14.2334 16.9573 14.3025 16.9499C14.3717 16.9425 14.4377 16.9171 14.494 16.8762C14.5503 16.8353 14.5948 16.7804 14.6232 16.7169C14.6516 16.6534 14.6629 16.5836 14.6559 16.5144L14.6558 16.5142L14.2288 12.3012L14.2041 12.0576L14.3673 11.875L17.1886 8.71743L12.8376 7.16736ZM12.8376 7.16736L16.9764 8.06404M12.8376 7.16736L16.9764 8.06404M16.9764 8.06404C16.9765 8.06406 16.9765 8.06408 16.9766 8.0641M16.9764 8.06404L16.9766 8.0641M16.9766 8.0641C17.0444 8.07888 17.1072 8.11116 17.1587 8.15774C17.2102 8.20437 17.2487 8.26369 17.2701 8.3298C17.2916 8.3959 17.2954 8.46648 17.2811 8.53449C17.2668 8.60244 17.2349 8.66545 17.1887 8.71727L16.9766 8.0641Z"
      fill="#FFC700"
      stroke="#FFC700"
      stroke-width="1.11111"
    />
  </svg>
);
